//#region Style
import './Builder.scss';
//#endregion
//#region Misc
import * as angular from 'angular';
import { GrabToPan } from 'assets/js/grab-to-pan';
import { immutableSplice } from 'data/array';
import { debounce } from 'data/function';
import 'data/storage';
import { v4 as uuid } from 'uuid';
import { BuilderStore } from './store/BuilderStore';
import { BuilderMigrateFlows } from './BuilderMigrateFlows';
import { CodeEditorFeatures } from 'modules/application/detail/portal-submodule-builder/templates/builder/CodeEditorFeatures';
import { BuilderFeatures } from './BuilderFeatures';
import { BuilderAttendanceRulesSidebarFeatures } from './attendanceRules/BuilderAttendanceRulesSidebarFeatures';
import { BuilderConfigurationsSidebarFeatures } from './configurations/BuilderConfigurationsSidebarFeatures';
//#endregion
//#region Segment Events
import { BUILDER_BLOCK_CREATED, BUILDER_BLOCK_MOVE_STATE, BUILDER_BLOCK_MOVE_STATES, BUILDER_BLOCK_SKILLS_SIDEBAR_OPENED, BUILDER_BLOCK_SUBFLOW_CREATED, } from './BuilderSegmentEvents';
//#endregion
//#region Controllers
import { BuilderSidebarController } from './BuilderSidebarController';
import { BuilderConfigurationSidebarController } from './configurations/BuilderConfigurationSidebarController';
import { BuilderAttendanceRulesSidebarController } from './attendanceRules/BuilderAttendanceRulesSidebarController';
import { VarLibraryController } from './varLibrary/VarLibraryController';
import { PreparedBlocksController } from './preparedBlocks/PreparedBlocksController';
import { PreparedBlocksSidebarController } from './preparedBlocks/PreparedBlocksSidebarController';
//#endregion
//#region Views
import '!ng-cache-loader!./BuilderCommandButtons.html';
import BuilderSidebarView from './BuilderSidebarView.html';
import BuilderConfigurationSidebarView from './configurations/BuilderConfigurationSidebarView.html';
import BuilderAttendanceRulesSidebarView from './attendanceRules/BuilderAttendanceRulesSidebarView.html';
import VarLibraryView from './varLibrary/VarLibraryView.html';
import PreparedBlocksView from './preparedBlocks/PreparedBlocksView.html';
import PreparedBlocksSidebarView from './preparedBlocks/PreparedBlocksSidebarView.html';
//#endregion
//#region Modals
import { ConfirmationModal } from 'modules/ui';
import chooseOrCreateSubFlowModal from 'modules/application/detail/portal-submodule-builder/templates/builder/subflow/chooseOrCreate';
import createSubFlowModal from 'modules/application/detail/portal-submodule-builder/templates/builder/subflow/create';
import copilotModal from 'modules/application/detail/portal-submodule-builder/templates/builder/copilot';
import feedbackModal from './copilot/feedbackModal';
import installSmartSalesPluginModal from 'modules/application/detail/portal-submodule-builder/templates/builder/smartSales/installPlugin';
//#endregion
//#region Actions
import { AddStateIAction, CardOutputContentIAction, DeleteStateIAction, DuplicateStateIAction, MoveStateIAction, MoveStatesIAction, UpdateStateIAction, } from './historyActions';
import { DeleteStatesIAction } from './historyActions/DeleteStatesIAction';
import { DuplicateStatesIAction } from './historyActions/DuplicateStatesIAction';
import { UpdateStatesIAction } from './historyActions/UpdateStatesIAction';
import { FlowViewModel } from './models/viewModels/FlowViewModel';
import { OutputViewModel } from './models/viewModels/OutputViewModel';
import { ActionType } from './models/Action';
import { FlowViewModelValidator } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/FlowViewModelValidator';
import { SubflowViewModelValidator } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/SubflowViewModelValidator';
import { ValidationError } from 'modules/application/detail/portal-submodule-builder/templates/builder/models/validators/ValidatorError';
import { GlobalStateViewModelValidator } from './models/validators/GlobalStateViewModelValidator';
import { SubflowStateViewModelValidator } from './models/validators/SubflowStateViewModelValidator';
import { StateViewModelValidator } from './models/validators/StateViewModelValidator';
//#endregion
//#region Services
import { AI_ANSWERS_TEMPLATE_TYPE, CONTENT_TEMPLATE_TYPE, DESK_ID_PREFIX, DESK_TEMPLATE_TYPE, STATE_ID_END, STATE_ID_ERROR, STATE_ID_FALLBACK, STATE_ID_FIRST_BLOCK_SUBFLOW, STATE_ID_ONBOARDING, STATE_ID_WELCOME, SUBFLOW_ID_PREFIX, SUBFLOW_TEMPLATE_TYPE, SURVEY_ID_PREFIX, ANSWERS_ID_PREFIX, PAYMENT_ID_PREFIX, } from 'modules/application/detail/portal-submodule-builder/templates/builder/services/BuilderStateService';
import { PaymentConstants } from './payment/PaymentConstants';
import { LockImplementation } from './services/BuilderService';
import { DEFAULT_CONNECTOR_COLOR } from './services/JsPlumbService';
import { SubflowFlowStatus, SubflowModalAction } from './services/SubflowService';
import { AppCuesService } from 'modules/shared/AppCuesService';
import { ToastType } from 'modules/application/misc/ToastService';
import { SmartSalesConstants } from './smartSales/SmartSalesConstants';
//#endregion
//#region Templates
import SatisfactionSurveyModel from './preparedBlocks/resources/attendanceSatisfactionSurvey.json';
import { SubflowConfigurationWithShortName } from './models/SubflowConfigurationWithShortName';
//#endregion
//#region Exclusive Components
import ExclusiveComponentsModalView from './exclusiveComponents/modals/ExclusiveComponentsModalView.html';
import { ExclusiveComponentsModalController } from './exclusiveComponents/modals/ExclusiveComponentsModalController';
import './exclusiveComponents/ExclusiveComponents.scss';
import { CrossAppFeatures } from 'modules/shared/featureToggle/CrossAppFeatures';
import { AgentState, AiAgentConstants } from './aiAgent/AiAgentConstants';
import { PlanStatus } from './studio/types/plan';
import UpdateVersionModal from './studio/components/UpdateVersionModal';
import { ContractActivationOrigins } from './studio/services/StudioSegmentService';
//#endregion
const connectionStyle = (source, target) => {
    const style = {
        source,
        target,
        anchor: undefined,
        anchors: undefined,
        paintStyle: {
            stroke: DEFAULT_CONNECTOR_COLOR,
            strokeWidth: 2,
            outlineStroke: 'transparent',
            outlineWidth: 4,
        },
        connectorStyle: {
            stroke: DEFAULT_CONNECTOR_COLOR,
            strokeWidth: 2,
            outlineStroke: 'transparent',
            outlineWidth: 4,
        },
        connectionType: 'basic',
        Endpoint: ['Dot', { radius: 15 }],
        endpointStyle: { fill: 'transparent' },
    };
    if (source === target) {
        style.anchors = [[0, 0.10, -1, 0], [0.05, 0, 0, -1]];
    }
    else {
        style.anchor = 'Continuous';
    }
    return style;
};
var HistoryActionsEnum;
(function (HistoryActionsEnum) {
    HistoryActionsEnum["ActionTabIAction"] = "ChangeAction";
    HistoryActionsEnum["AddStateIAction"] = "AddState";
    HistoryActionsEnum["DuplicateStateIAction"] = "DuplicateState";
    HistoryActionsEnum["UpdateStateIAction"] = "UpdateState";
    HistoryActionsEnum["DuplicateStatesIAction"] = "DuplicateStates";
    HistoryActionsEnum["CardContentIAction"] = "ChangeCardContent";
    HistoryActionsEnum["ContentActionTabIAction"] = "ChangeContent";
    HistoryActionsEnum["DeleteStateIAction"] = "RemoveState";
    HistoryActionsEnum["DeleteStatesIAction"] = "RemoveStates";
    HistoryActionsEnum["MoveStateIAction"] = "MoveState";
    HistoryActionsEnum["MoveStatesIAction"] = "MoveStates";
    HistoryActionsEnum["CardOutputContentIAction"] = "ChangeOutput";
    HistoryActionsEnum["CardOutputConditionIAction"] = "ChangeConditionOutput";
    HistoryActionsEnum["StateTagsIAction"] = "ChangeTags";
    HistoryActionsEnum["StateTitleIAction"] = "ChangeTitle";
})(HistoryActionsEnum || (HistoryActionsEnum = {}));
//#region Constants
export const CloseEditorIfOpenedEvent = 'CloseEditorIfOpened';
export const GLOBAL_ACTIONS = 'global-actions';
export const BUILDER_SAVING_TIMEOUT = 2000;
export const BUILDER_HAS_ACCESSED = 'builder_has_accessed';
const EngineLocaltimezoneKey = 'builder:#localTimeZone';
const SouthAmericaTimezone = 'E. South America Standard Time';
const RIGHT_CLICK_BUTTON = 2;
const executeScriptActionType = 'ExecuteScript';
const BUILDER_PUBLISH_DEBOUNCE_TIME = 2000;
const BUILDER_PERMISSION_CLAIM = 114;
const WRITE_PERMISSION_ACTION = 3;
//#endregion
const builderStore = BuilderStore.getInstance();
export class BuilderController {
    static $inject = ['JsPlumbService', 'BuilderService', 'AlertService', 'TenantService', 'BuilderStateService', 'SavingService', 'BuilderSegmentService', 'SegmentService', 'SidebarContentService', 'TagsService', 'VariablesService', '$scope', '$rootScope', '$timeout', 'LoadingService', 'ChatbotSettingsService', 'ngToast', '$translate', '$document', '$stateParams', 'application', 'ModalService', '$state', 'BlipService', 'ChatService', 'ApplicationService2', 'UndoRedoService', 'clipboard', 'ContextMenuService', 'SubflowService', 'ActionContentService', 'SmartSalesService', 'TranslateService', 'CopilotAdapterService', 'AnswersService', 'ExclusiveComponentsService', 'BuilderAiAgentService', 'StudioService', 'AgentContextService', 'FlowVariablesService', 'StudioVersionService'];
    // is a payment block
    isPaymentId(stateId) {
        return stateId?.startsWith(PAYMENT_ID_PREFIX);
    }
    constructor(JsPlumbService, BuilderService, AlertService, TenantService, BuilderStateService, SavingService, BuilderSegmentService, SegmentService, SidebarContentService, TagsService, VariablesService, $scope, $rootScope, $timeout, LoadingService, ChatbotSettingsService, ngToast, $translate, $document, $stateParams, application, ModalService, $state, BlipService, ChatService, ApplicationService2, UndoRedoService, clipboard, ContextMenuService, //external service has no type
    BlipToastService, SubflowService, ActionContentService, SmartSalesService, TranslateService, CopilotAdapterService, AnswersService, ExclusiveComponentsService, BuilderAiAgentService, StudioService, AgentContextService, FlowVariablesService, StudioVersionService) {
        'ngInject';
        this.JsPlumbService = JsPlumbService;
        this.BuilderService = BuilderService;
        this.AlertService = AlertService;
        this.TenantService = TenantService;
        this.BuilderStateService = BuilderStateService;
        this.SavingService = SavingService;
        this.BuilderSegmentService = BuilderSegmentService;
        this.SegmentService = SegmentService;
        this.SidebarContentService = SidebarContentService;
        this.TagsService = TagsService;
        this.VariablesService = VariablesService;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.LoadingService = LoadingService;
        this.ChatbotSettingsService = ChatbotSettingsService;
        this.ngToast = ngToast;
        this.$translate = $translate;
        this.$document = $document;
        this.$stateParams = $stateParams;
        this.application = application;
        this.ModalService = ModalService;
        this.$state = $state;
        this.BlipService = BlipService;
        this.ChatService = ChatService;
        this.ApplicationService2 = ApplicationService2;
        this.UndoRedoService = UndoRedoService;
        this.clipboard = clipboard;
        this.ContextMenuService = ContextMenuService;
        this.BlipToastService = BlipToastService;
        this.SubflowService = SubflowService;
        this.ActionContentService = ActionContentService;
        this.SmartSalesService = SmartSalesService;
        this.TranslateService = TranslateService;
        this.CopilotAdapterService = CopilotAdapterService;
        this.AnswersService = AnswersService;
        this.ExclusiveComponentsService = ExclusiveComponentsService;
        this.BuilderAiAgentService = BuilderAiAgentService;
        this.StudioService = StudioService;
        this.AgentContextService = AgentContextService;
        this.FlowVariablesService = FlowVariablesService;
        this.StudioVersionService = StudioVersionService;
        this.isFirstLoop = true;
        this.copiedStates = [];
        this.pastedStates = [];
        this.searchedStates = [];
        this.cachedSearchResults = {};
        this.userHasEditingPermission = false;
        this.multipleBlocksCounter = 0;
        this.undoRedoButtonClicked = false;
        this.undoLimitExceededToastIsOn = false;
        this.redoLimitExceededToastIsOn = false;
        this.segmentPayload = {};
        this.isBuilderPreparedBlocksEnabled = false;
        this.showPreparedBlocksButton = false;
        this.canEditRule = false;
        this.canSeeRule = false;
        this.hasAttendanceBlock = false;
        this.tipsDelimiters = '\r\n?|\n/,\|;/';
        this.isLocalTimezoneEnabled = false;
        this.isAddingBlocks = false;
        this.hasPermissionToAccessSubflow = false;
        this.hasPermissionToCreateBlocksWithCopilot = false;
        this.isEditingSubflow = false;
        this.areKeyboardActionsEnabled = true;
        this.isFullscreen = false;
        this.subflowsShortNames = [];
        this.showBuilderChannelsExclusiveComponents = false;
        this.useFooterWithBlipStatus = false;
        this.useConfigurationsApplication = false;
        this.isSelectingRegion = false;
        this.showGroundingToolsMigrationAlert = false;
        this.hasPermissionToAccessAiAnswers = false;
        this.hasAgentBlockToUpdate = false;
        this.agentBlocksThatNeedUpdate = new Set();
        this.handleOnKeyDown = e => {
            // Some screen states will disable all keyboard actions,
            // like a modal being opened, for instance.
            if (!this.areKeyboardActionsEnabled) {
                return;
            }
            const evtobj = window.event ? event : e;
            const isMacOsCmd = e => e.keyCode == 90 && e.metaKey;
            const isWindowsCtrl = e => e.keyCode == 90 && e.ctrlKey;
            const isWindowsCtrlY = e => e.keyCode == 89 && e.ctrlKey;
            if (e.shiftKey && !(e.key.includes('Shift'))) {
                this.debouncedTrackCtrlShiftCommand(e);
            }
            else if (e.metaKey || e.ctrlKey && e.key !== 'Control' && e.key !== 'Command') {
                this.debouncedTrackCtrlCommand(e);
            }
            // Ctrl/cmd + z
            if ((isMacOsCmd(evtobj) || isWindowsCtrl(evtobj)) && !e.shiftKey) {
                this.debouncedHandleUndoAction();
            }
            // Ctrl/cmd + shift + z || Ctrl + y
            if ((isMacOsCmd(evtobj) || isWindowsCtrl(evtobj)) && e.shiftKey || isWindowsCtrlY(evtobj)) {
                this.debouncedHandleRedoAction();
            }
            this.undoRedoButtonClicked = false;
        };
        this.subFlowDeleteAlert = async () => {
            await this.AlertService.show({
                title: await this.$translate('builder.subflow.deleteSubflowModalTitle'),
                body: await this.$translate('builder.subflow.deleteSubflowModalDescription'),
                variant: 'delete',
                icon: 'trash',
                buttons: {
                    cancel: await this.$translate('builder.subflow.deleteSubflowModalButtonNo'),
                    confirm: await this.$translate('builder.subflow.deleteSubflowModalButtonYes'),
                },
                callback: {
                    cancelButtonAction: () => { },
                    confirmButtonAction: async () => { this.deleteSelectedState(); },
                },
            });
        };
        this.isValidJson = (text) => {
            try {
                JSON.parse(text);
                return true;
            }
            catch {
                return false;
            }
        };
        this.openUpdateVersionModal = () => {
            this.checkAllOutdatedAgentBlocks();
            this.ModalService.showModal(UpdateVersionModal({
                confirm: (blocks) => this.updateVersionBlock(blocks),
                agentBlocksThatNeedUpdate: this.agentBlocksThatNeedUpdate,
            }));
        };
        this.updateVersionBlock = async (blocks) => {
            try {
                this.StudioVersionService.updateAiBlockVersion(blocks);
                await this.saveFlow();
                this.BlipToastService.show('success', {
                    title: this.$translate.instant('versioning.toast.successTitle'),
                    msg: this.$translate.instant('versioning.toast.successMessage')
                });
            }
            catch (error) {
                this.BlipToastService.show('danger', {
                    title: this.$translate.instant('versioning.toast.errorTitle'),
                    msg: this.$translate.instant('versioning.toast.errorMessage')
                });
            }
        };
        this.subflowStateViewModelValidator = new SubflowStateViewModelValidator();
        this.stateViewModelValidator = new StateViewModelValidator();
        this.globalStateViewModelValidator = new GlobalStateViewModelValidator();
        this.flowViewModelValidator = new FlowViewModelValidator();
        this.subflowViewModelValidator = new SubflowViewModelValidator();
        this.editingState = undefined;
        this.BuilderSegmentService.page();
        this.debouncedEditState = debounce(this.editState, 500, true);
        this.debouncedHandleUndoAction = debounce(this.handleUndoAction, 100);
        this.debouncedHandleRedoAction = debounce(this.handleRedoAction, 100);
        this.debouncedTrackCtrlCommand = debounce((e) => {
            const segmentPayload = { Command: String('Ctrl + ' + e.code.replace('Key', '')) };
            this.trackFlowCommands(true, segmentPayload);
        }, 100);
        this.debouncedTrackCtrlShiftCommand = debounce((e) => {
            const segmentPayload = { Command: String('Ctrl + Shift + ' + e.code.replace('Key', '')) };
            this.trackFlowCommands(true, segmentPayload);
        }, 100);
        this.debouncedMakeSearch = debounce(this.makeSearch, 500);
        this.debouncedSave = debounce(this.saveFlow, BUILDER_SAVING_TIMEOUT);
        this.BuilderSegmentService.setApplication(this.application);
        this.localStorage = window.localStorage;
        this.migrateFlows = new BuilderMigrateFlows();
    }
    async $onInit() {
        // Check which command key is used for copying
        this.commandKey = window.navigator.userAgent.toLowerCase().startsWith('mac')
            ? '⌘'
            : 'Ctrl';
        this.isLoading = true;
        this.LoadingService.startLoading(false);
        await this.checkFeatures();
        this.SmartSalesService.setApplication(this.application, this.useConfigurationsApplication);
        await this.checkPermissions();
        await this.getToastMessages();
        this.defaultNodeTitle = this.$translate.instant('builder.node.defaultTitle');
        this.initializeUndoRedoListener();
        if (this.isBuilderPreparedBlocksEnabled) {
            this.showPreparedBlocksButton = this.TranslateService.getCurrentLanguage() == 'pt';
        }
        // Reset tags list on every bot
        this.TagsService.tags = [];
        this.$scope.$on('ToggleZoomClose', () => {
            this.isZoomOpen = false;
        });
        const startTime = Date.now();
        try {
            this.initializeVariables();
            const canvas = document.getElementById('canvas');
            let selectionDiv = null;
            let startX = 0, startY = 0;
            canvas.addEventListener('click', (event) => {
                this.setAddingBlockValue(false);
                this.closeSidebar();
                if (!event.shiftKey) {
                    this.deselectAllNodes();
                }
                if (event.shiftKey) {
                    this.isSelectingRegion = true;
                    canvas.style.cursor = 'default';
                    const rect = canvas.getBoundingClientRect();
                    startX = event.clientX - rect.left;
                    startY = event.clientY - rect.top;
                    selectionDiv = document.createElement('div');
                    selectionDiv.style.position = 'absolute';
                    selectionDiv.style.border = '0.5px solid rgba(255, 255, 255, 0.2)';
                    selectionDiv.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
                    selectionDiv.style.pointerEvents = 'none';
                    selectionDiv.style.left = `${startX}px`;
                    selectionDiv.style.top = `${startY}px`;
                    selectionDiv.style.width = '0px';
                    selectionDiv.style.height = '0px';
                    canvas.parentElement.appendChild(selectionDiv);
                }
                else if (selectionDiv) {
                    setTimeout(() => {
                        selectionDiv.remove();
                        selectionDiv = null;
                    }, 500);
                }
            });
            canvas.addEventListener('mousedown', (event) => {
                this.setAddingBlockValue(false);
                this.closeSidebar();
                if (!event.shiftKey) {
                    this.deselectAllNodes();
                }
                if (event.shiftKey) {
                    this.isSelectingRegion = true;
                    canvas.style.cursor = 'default';
                    const rect = canvas.getBoundingClientRect();
                    startX = event.clientX - rect.left;
                    startY = event.clientY - rect.top;
                    selectionDiv = document.createElement('div');
                    selectionDiv.style.position = 'absolute';
                    selectionDiv.style.border = '0.5px solid rgba(255, 255, 255, 0.2)';
                    selectionDiv.style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
                    selectionDiv.style.pointerEvents = 'none';
                    selectionDiv.style.left = `${startX}px`;
                    selectionDiv.style.top = `${startY}px`;
                    selectionDiv.style.width = '0px';
                    selectionDiv.style.height = '0px';
                    canvas.parentElement.appendChild(selectionDiv);
                }
            });
            canvas.addEventListener('mousemove', (event) => {
                if (this.isSelectingRegion && selectionDiv) {
                    const rect = canvas.getBoundingClientRect();
                    const currentX = event.clientX - rect.left;
                    const currentY = event.clientY - rect.top;
                    const width = currentX - startX;
                    const height = currentY - startY;
                    selectionDiv.style.width = `${Math.abs(width)}px`;
                    selectionDiv.style.height = `${Math.abs(height)}px`;
                    selectionDiv.style.left = `${Math.min(startX, currentX)}px`;
                    selectionDiv.style.top = `${Math.min(startY, currentY)}px`;
                }
            });
            canvas.addEventListener('mouseup', () => {
                if (this.isSelectingRegion) {
                    this.isSelectingRegion = false;
                    if (selectionDiv) {
                        const selectionBounds = selectionDiv.getBoundingClientRect();
                        const nodes = document.querySelectorAll('.diagram-node');
                        nodes.forEach(node => {
                            const nodeBounds = node.getBoundingClientRect();
                            if (nodeBounds.left >= selectionBounds.left &&
                                nodeBounds.right <= selectionBounds.right &&
                                nodeBounds.top >= selectionBounds.top &&
                                nodeBounds.bottom <= selectionBounds.bottom) {
                                this.selectNode(node);
                            }
                        });
                        selectionDiv.remove();
                        selectionDiv = null;
                    }
                }
            });
            document.addEventListener('keyup', (event) => {
                if (event.key === 'Shift' && this.isSelectingRegion) {
                    this.isSelectingRegion = false;
                    if (selectionDiv) {
                        selectionDiv.remove();
                        selectionDiv = null;
                    }
                }
            });
            this.setupGrapToPan(canvas);
            this.setupJsPlumb(canvas);
            this.builderInstance.setSuspendDrawing(true);
            this.setScrollListener(canvas);
            setTimeout(() => {
                this.setBuilderZoom();
            }, 1000);
            const flow = await this.initializeApplicationAndReturnFlow();
            // Initialize agent contexts from loaded flow
            this.AgentContextService.updateFromFlow(flow);
            // Check if should show grounding tools migration alert
            this.showGroundingToolsMigrationAlert = await this.shouldAlertUserAboutGroundingToolsMigration();
            const pasteListener = this.$document.on('paste', async (event) => this.onPasteEvent(event));
            this.$scope.$on('$destroy', () => pasteListener.unbind());
            // Guarantees the navbar is shown when leaving
            this.$scope.$on('$destroy', () => {
                this.setFullscreen(false);
            });
            // Add the handler for 'delete' blocks using the keyboard
            const deleteListener = this.$document.on('keydown', async (event) => {
                if (event instanceof KeyboardEvent) {
                    event.stopPropagation();
                    this.keyboardListener(event);
                }
            });
            this.$scope.$on('$destroy', () => deleteListener.unbind());
            // Add handler to deselect nodes.
            const clickListener = this.$document.on('click', (event) => {
                if (event instanceof MouseEvent) {
                    const element = event.target;
                    if (element &&
                        !element.classList.contains('diagram-node') &&
                        !element.classList.contains('builder-node-title')) {
                        if (!event.shiftKey) {
                            this.deselectAllNodes();
                        }
                    }
                }
            });
            this.$scope.$on('$destroy', () => clickListener.unbind());
            await this.checkUserPermission();
            if (this.userHasEditingPermission) {
                // Write lock to avoid concurrent changes in the flow
                await this.tryGetWriteLock(true);
            }
            if (this.isAttendanceRulesBuilderEnabled) {
                this.checkAttendanceBlock(flow);
            }
            if (!this.application.isSubflow) {
                this.updateConfigurationOfAllSubflowStates();
            }
            if (this.hasPermissionToAccessAiAnswers) {
                this.answersConfiguration = await this.AnswersService.fetchConfiguration();
            }
            this.$timeout(() => AppCuesService.instance.start());
            this.changeCanvasPositionInSubflowStateIsNecessary();
            this.selectNodeByStateParamsIfNecessary();
            const endTime = Date.now();
            this.trackFlowLoaded(true, (endTime - startTime) / 1000);
            this.$timeout(() => this.saveFlow());
            this.onLeavingFromDeskSettings = await this.BuilderService.getOnLeavingFromDeskSettings();
            this.getLatestAgentVersion();
        }
        catch (e) {
            console.error(e);
            const endTime = Date.now();
            this.trackFlowLoaded(false, (endTime - startTime) / 1000);
            const errorMsg102 = await this.$translate('utils.errorMsg.102');
            this.ngToast.danger(errorMsg102);
        }
        finally {
            this.LoadingService.stopLoading();
            this.isLoading = false;
            this.builderInstance.setSuspendDrawing(false, true);
            this.$timeout(() => { this.BuilderService.validateTab('config-tooltip', this.globalActions); }, 1000);
        }
    }
    initializeVariables() {
        this.selectedNodes = [];
        this.hasOldConn = false;
        this.isCleaning = false;
        this.isSaving = false;
        this.isZoomOpen = false;
        this.isEditingSubflow = false;
    }
    async initializeApplicationAndReturnFlow() {
        let flow;
        if (this.application.isSubflow) {
            this.flowId = this.application.applicationJson.settings.flow.id;
            this.isEditingSubflow = true;
            const initialGlobalActions = {
                '$contentActions': [],
                '$conditionOutputs': [],
                '$enteringCustomActions': [],
                '$leavingCustomActions': [],
                '$inputSuggestions': [],
                '$tags': [],
                '$defaultOutput': {
                    'stateId': STATE_ID_FALLBACK,
                },
                'id': 'global-actions',
            };
            this.globalActions = initialGlobalActions;
            flow = await this.SubflowService.getEditedFlowOfSubflow(this.application.shortName, FlowViewModel.create(this.application.applicationJson.settings.flow));
            Object.keys(flow).forEach((key) => (flow[key] = this.fillStateViewProperties(flow[key])));
            this.configuration = await this.SubflowService.getEditedSubflowConfiguration(this.application.shortName);
            this.setInMemoryFlow(flow, this.flowId);
        }
        else {
            flow = await this.BuilderService.getFlow(this.application);
            Object.keys(flow).forEach((key) => (flow[key] = this.fillStateViewProperties(flow[key])));
            this.flowId = await this.BuilderService.getFlowId(this.application);
            this.setInMemoryFlow(flow, this.flowId);
            this.configuration = await this.BuilderService.getFlowConfiguration();
            if (this.isBuilderSecretConfigurationEnabled) {
                this.secretConfiguration = await this.BuilderService.getFlowSecretConfiguration();
                this.secretConfigurationCurrentItems = { ...this.secretConfiguration };
            }
            this.globalActions = await this.BuilderService.getGlobalActionsState();
        }
        if (this.isBuilderSecretConfigurationEnabled) {
            this.VariablesService.setVariablesSecretConfiguration(this.flow, this.configuration, this.secretConfiguration);
        }
        else {
            this.VariablesService.setVariables(this.flow, this.configuration);
        }
        // Update agent contexts and flow output variables from the flow
        this.AgentContextService.updateFromFlow(this.flow);
        this.FlowVariablesService.updateFromFlow(this.flow, this.configuration);
        return flow;
    }
    async getToastMessages() {
        this.limitExceededTitle = await this.$translate('builder.limitExceededTitle');
        this.limitExceededDescription = await this.$translate('builder.limitExceededDescription');
        this.noAttendanceBlockTitle = await this.$translate('builder.noAttendanceBlockTitle');
        this.noAttendanceBlockDescription = await this.$translate('builder.noAttendanceBlockDescription');
    }
    async checkFeatures() {
        const isMainFlow = !this.application.isSubflow;
        this.tenantId = await this.TenantService.getTenantPrefixFromUrl();
        this.isCloseScriptTabEnabled = await CodeEditorFeatures.isCloseScriptTabEnabled();
        this.isUndoRedoBlockPositionEnabled = await BuilderFeatures.builderUndoRedoBlockPositionEnabled();
        this.isUndoRedoMultipleBlocksAddRemoveEnabled = await BuilderFeatures.builderUndoRedoAddRemoveMultipleBlocksEnabled() || true;
        this.isBuilderUndoRedoOutputsEnabled = await BuilderFeatures.builderUndoRedoOutputsEnabled();
        this.isAttendanceRulesBuilderEnabled = isMainFlow && await BuilderFeatures.attendanceRulesBuilderEnabled();
        this.isSmartSalesBuilderEnabled = isMainFlow && await BuilderFeatures.smartSalesBuilderEnabled();
        this.isAiAnswersEnabled = await BuilderFeatures.aiAnswersEnabled();
        this.isLocalTimezoneEnabled = await BuilderFeatures.builderLocalTimeZoneEnabled();
        this.lineManagementInBuilder = await BuilderAttendanceRulesSidebarFeatures.queueManagementInBuilderEnabled();
        this.hasPermissionToAccessSubflow = !!this.tenantId && isMainFlow && await BuilderFeatures.hasPermissionToAccessSubflowEnabled();
        this.hasPermissionToCreateBlocksWithCopilot = await BuilderFeatures.hasPermissionToCreateBlocksWithCopilotEnabled();
        this.isBuilderImprovedCopyPasteFeatureEnabled = await BuilderFeatures.isBuilderImprovedCopyPasteFeatureEnabled();
        this.showBuilderChannelsExclusiveComponents = await BuilderFeatures.showBuilderChannelsExclusiveComponents();
        this.isBuilderWidgetBlipChatHelpCenterEnabled = await BuilderFeatures.builderWidgetBlipChatHelpCenterEnabled();
        this.isBuilderSecretConfigurationEnabled = await BuilderConfigurationsSidebarFeatures.isBuilderSecretConfigurationEnabled();
        this.isBuilderPreparedBlocksEnabled = await BuilderFeatures.isBuilderPreparedBlocksEnabled();
        this.useFooterWithBlipStatus = await CrossAppFeatures.useFooterWithBlipStatus();
        this.useConfigurationsApplication = await BuilderFeatures.isUseConfigurationsDomainOnMiscOperationsGetEnabled();
        this.isStudioPaymentBlockEnabled = await BuilderFeatures.isStudioPaymentBlockEnabled();
        this.isStudioEnabled = await this.StudioService.shouldEnableStudioFeatures();
        this.isStudioVersioningEnabled = await BuilderFeatures.isStudioVersioningEnabled();
        this.isStudioGroundingToolsMigrationEnabled = await BuilderFeatures.isStudioGroundingToolsMigrationEnabled();
        await this.StudioService.trackStudioActivation(ContractActivationOrigins.Builder);
        if (this.isStudioEnabled) {
            this.studioPlanStatus = PlanStatus.ACTIVE;
            this.isAiAgentCreateBuilderBlockEnabled = true;
        }
        else {
            this.studioPlanStatus = await this.StudioService.shouldShowTrialRegisterOption();
            this.isAiAgentCreateBuilderBlockEnabled = this.studioPlanStatus !== PlanStatus.NONE && this.studioPlanStatus !== PlanStatus.AVAILABLE_TO_TRIAL;
        }
        if (!this.localStorage.getItem(BUILDER_HAS_ACCESSED)) {
            this.localStorage.setItem(BUILDER_HAS_ACCESSED, 'true');
        }
        this.displayUpgradeDeskVersion = await BuilderFeatures.displayUpgradeDeskVersion();
        this.account = await this.ApplicationService2.getAccount();
    }
    async checkPermissions() {
        this.hasPermissionToAccessAiAnswers = await this.AnswersService.isEnabled();
        this.checkDeskPermission();
    }
    toggleAddingBlocks() {
        this.isAddingBlocks = !this.isAddingBlocks;
    }
    setInMemoryFlow(flow, flowId) {
        this.migrateFlows.migrate(this.application, flow);
        this.startSubscribers();
        builderStore.setFlow(flow, flowId);
    }
    startSubscribers() {
        const flowChanges$ = builderStore
            .getFlowChanges()
            .subscribe(({ editingFlow, editingFlowId }) => {
            if (editingFlowId == this.flowId) {
                this.flow = angular.copy(editingFlow);
            }
        });
        const stateChanges$ = builderStore
            .getStateChanges()
            .subscribe(data => {
            if (data?.id) {
                try {
                    const _stateChanges = angular.copy(data);
                    if (data.id !== GLOBAL_ACTIONS) {
                        this.flow[_stateChanges.id] = _stateChanges;
                        this.bindStateConnections(data.id);
                    }
                    else {
                        this.globalActions.$enteringCustomActions = _stateChanges.$enteringCustomActions;
                        this.globalActions.$leavingCustomActions = _stateChanges.$leavingCustomActions;
                    }
                }
                catch (e) {
                    console.error(e);
                }
                finally {
                    this.saveFlow();
                }
            }
        });
        this.$scope.$on('$destroy', () => {
            flowChanges$.unsubscribe();
            stateChanges$.unsubscribe();
        });
    }
    async onPasteEvent(event) {
        if (!this.areKeyboardActionsEnabled) {
            return;
        }
        // Pasting into a text input. The browser will handle.
        if (document.activeElement.nodeName == 'TEXTAREA' || document.activeElement.nodeName == 'INPUT') {
            return;
        }
        const items = event.clipboardData.items;
        if (!items.length) {
            return;
        }
        let dataItem;
        for (const item of items) {
            if (item.kind == 'string' && item.type == 'text/plain') {
                dataItem = item;
                break;
            }
        }
        if (!dataItem) {
            dataItem = items[0];
        }
        dataItem.getAsString(async (data) => await this.duplicateUndoRedoStateClipboard(data));
    }
    initializeUndoRedoListener() {
        document.addEventListener('keydown', this.handleOnKeyDown);
        // Remove listeners when leave this page
        this.$scope.$on('$destroy', () => {
            document.removeEventListener('keydown', this.handleOnKeyDown);
            this.UndoRedoService.clear();
        });
    }
    // Get the type of the sidebar content that has changed with an action
    getNewContentType(beforeData, afterData) {
        if (beforeData && afterData) {
            const beforeDataKeys = Object.keys(beforeData);
            const afterDataKeys = Object.keys(beforeData);
            for (let i = 0; i < beforeDataKeys.length; i++) {
                let beforeDataIndex = beforeData[beforeDataKeys[i]];
                let afterDataIndex = afterData[afterDataKeys[i]];
                // Get the document property of each object (beforeData and afterData)
                if (beforeDataIndex?.action) {
                    beforeDataIndex = beforeDataIndex?.action?.$cardContent?.document;
                }
                else {
                    beforeDataIndex = beforeDataIndex?.input?.$cardContent?.document;
                }
                if (afterDataIndex?.action) {
                    afterDataIndex = afterDataIndex?.action?.$cardContent?.document;
                }
                else {
                    afterDataIndex = afterDataIndex?.input?.$cardContent?.document;
                }
                // Check if object IDs are different
                // If true, return the type of the content that has changed
                if (beforeDataIndex?.id != afterDataIndex?.id) {
                    if (beforeDataKeys.length > afterDataKeys.length) {
                        return beforeDataIndex?.type;
                    }
                    else {
                        return afterDataIndex?.type;
                    }
                }
            }
        }
    }
    trackUndoRedoActions(historyAction, isUndoAction, segmentPayload) {
        const actionPerformed = String(historyAction.constructor.name);
        let trackingParameter = undefined;
        let undoBlockContent = false;
        let undoBlockOutput = false;
        let undoBlockCrud = false;
        if (actionPerformed === 'ActionTabIAction') {
            trackingParameter = {
                BlockID: historyAction.data.state.id,
                Action: HistoryActionsEnum[actionPerformed],
                LimitReached: false,
                ButtonClicked: this.undoRedoButtonClicked,
                KeyboardUsed: !this.undoRedoButtonClicked,
            };
        }
        else if (actionPerformed === 'CardContentIAction' ||
            actionPerformed === 'ContentActionTabIAction') {
            trackingParameter = {
                BlockID: historyAction.data.state.id,
                Action: HistoryActionsEnum[actionPerformed],
                ButtonClicked: this.undoRedoButtonClicked,
                KeyboardUsed: !this.undoRedoButtonClicked,
                ContentType: this.getNewContentType(historyAction.data.before, historyAction.data.after) || 'text/plain',
            };
            undoBlockContent = true;
        }
        else if (actionPerformed === 'AddStateIAction' ||
            actionPerformed === 'DeleteStateIAction' ||
            actionPerformed === 'DeleteStatesIAction' ||
            actionPerformed === 'DuplicateStateIAction' ||
            actionPerformed === 'DuplicateStatesIAction' ||
            actionPerformed === 'MoveStateIAction' ||
            actionPerformed === 'MoveStatesIAction' ||
            actionPerformed === 'StateTagsIAction' ||
            actionPerformed === 'StateTitleIAction') {
            trackingParameter = {
                BlockID: historyAction.data.state.id,
                Action: HistoryActionsEnum[actionPerformed],
                ButtonClicked: this.undoRedoButtonClicked,
                KeyboardUsed: !this.undoRedoButtonClicked,
                ...segmentPayload,
            };
            undoBlockCrud = true;
        }
        else if (actionPerformed == 'CardOutputContentIAction' ||
            actionPerformed == 'CardOutputConditionIAction') {
            trackingParameter = {
                BlockID: historyAction.data.state.id,
                Action: HistoryActionsEnum[actionPerformed],
                ButtonClicked: this.undoRedoButtonClicked,
                KeyboardUsed: !this.undoRedoButtonClicked,
                ...segmentPayload,
            };
            undoBlockOutput = true;
        }
        else if (actionPerformed === 'CustomActionIAction') {
            return;
        }
        else {
            if (!historyAction || ['GlobalTabIAction', 'ConfigurationIAction'].includes(actionPerformed)) {
                return;
            }
            trackingParameter = {
                BlockID: historyAction.data.state.id,
                Action: 'ChangeContent',
                ContentType: this.getNewContentType(historyAction.data.before, historyAction.data.after) || 'text/plain',
                ...segmentPayload,
            };
            undoBlockContent = true;
        }
        if (isUndoAction) {
            if (undoBlockContent) {
                this.trackBlockContentUndo(true, trackingParameter);
            }
            if (undoBlockOutput) {
                this.trackBlockOutputUndo(true, trackingParameter);
            }
            if (undoBlockCrud) {
                this.trackBlockCrudUndo(true, trackingParameter);
            }
            if (trackingParameter && !undoBlockContent) {
                trackingParameter.ContentType = undefined;
                trackingParameter.LimitReached = false;
                trackingParameter.ButtonClicked = this.undoRedoButtonClicked;
                trackingParameter.KeyboardUsed = !this.undoRedoButtonClicked;
                this.trackBlockUndo(true, trackingParameter);
            }
        }
        else {
            if (undoBlockContent) {
                this.trackBlockContentRedo(true, trackingParameter);
            }
            if (undoBlockOutput) {
                this.trackBlockOutputRedo(true, trackingParameter);
            }
            if (undoBlockCrud) {
                this.trackBlockCrudRedo(true, trackingParameter);
            }
            if (trackingParameter && !undoBlockContent && !undoBlockOutput && !undoBlockCrud) {
                trackingParameter.ContentType = undefined;
                trackingParameter.LimitReached = false;
                trackingParameter.ButtonClicked = this.undoRedoButtonClicked;
                trackingParameter.KeyboardUsed = !this.undoRedoButtonClicked;
                this.trackBlockRedo(true, trackingParameter);
            }
        }
    }
    hasActiveElement() {
        const activeElement = document.activeElement;
        const isInputType = () => activeElement instanceof HTMLInputElement
            || activeElement instanceof HTMLTextAreaElement;
        return activeElement && isInputType();
    }
    /**
     * Method use in view template
     */
    async executeUndoAction() {
        this.undoRedoButtonClicked = true;
        await this.handleUndoAction();
    }
    async handleUndoAction() {
        try {
            if (this.hasActiveElement()) {
                return;
            }
            // Lock prevent new actions to be added when undone action
            this.UndoRedoService.lock();
            const historyAction = this.UndoRedoService.undo();
            const stateName = historyAction?.data?.state?.id === GLOBAL_ACTIONS ? historyAction?.data?.state?.id.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : historyAction?.data?.state?.$title.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            const undoTitle = await this.$translate('builder.undoTitle', { stateName });
            const undoDescription = await this.$translate('builder.undoDescription', { stateName });
            if (historyAction) {
                if (!this.UndoRedoService.getReverseStack().stackHasSpace()) {
                    this.BlipToastService.show('warning', {
                        title: this.limitExceededTitle,
                        msg: this.limitExceededDescription,
                        duration: 3000,
                    });
                    this.undoLimitExceededToastIsOn = true;
                    setTimeout(() => { this.undoLimitExceededToastIsOn = false; }, 3000);
                }
                else {
                    this.BlipToastService.show('undo', {
                        title: undoTitle,
                        msg: undoDescription,
                        duration: 3000,
                    });
                    this.trackUndoRedoActions(historyAction, true, this.segmentPayload);
                }
            }
            else if (!this.undoLimitExceededToastIsOn && !historyAction) {
                const noUndoTitle = await this.$translate('builder.noUndoTitle');
                const noUndoDescription = await this.$translate('builder.noUndoDescription');
                const trackingParameter = {
                    LimitReached: true,
                    ButtonClicked: this.undoRedoButtonClicked,
                    KeyboardUsed: !this.undoRedoButtonClicked,
                };
                if (!this.UndoRedoService.getNormalStack().stackHasItems()) {
                    this.BlipToastService.show('warning', {
                        title: noUndoTitle,
                        msg: noUndoDescription,
                        duration: 3000,
                    });
                }
                this.trackBlockUndo(true, trackingParameter);
                this.undoLimitExceededToastIsOn = true;
                setTimeout(() => { this.undoLimitExceededToastIsOn = false; }, 3000);
            }
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.UndoRedoService.unlock();
        }
    }
    /**
     * Method use in view template
     */
    async executeRedoAction() {
        await this.handleRedoAction();
    }
    async handleRedoAction() {
        try {
            if (this.hasActiveElement()) {
                return;
            }
            // Lock prevent new actions to be added when redone action
            this.UndoRedoService.lock();
            const historyAction = this.UndoRedoService.redo();
            const stateName = historyAction?.data?.state?.$title?.normalize('NFD').replace(/[\u0300-\u036f]/g, '') || historyAction?.data?.state?.id?.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            const redoTitle = await this.$translate('builder.redoTitle', { stateName });
            const redoDescription = await this.$translate('builder.redoDescription', { stateName });
            if (historyAction) {
                if (!this.UndoRedoService.getNormalStack().stackHasSpace()) {
                    this.BlipToastService.show('warning', {
                        title: this.limitExceededTitle,
                        msg: this.limitExceededDescription,
                        duration: 3000,
                    });
                    this.redoLimitExceededToastIsOn = true;
                    setTimeout(() => { this.redoLimitExceededToastIsOn = false; }, 3000);
                }
                else {
                    this.BlipToastService.show('redo', {
                        title: redoTitle,
                        msg: redoDescription,
                        duration: 3000,
                    });
                    this.trackUndoRedoActions(historyAction, false, this.segmentPayload);
                }
            }
            else if (!this.redoLimitExceededToastIsOn && !historyAction) {
                const noRedoTitle = await this.$translate('builder.noRedoTitle');
                const noRedoDescription = await this.$translate('builder.noRedoDescription');
                this.BlipToastService.show('warning', {
                    title: noRedoTitle,
                    msg: noRedoDescription,
                    duration: 3000,
                });
                const trackingParameter = {
                    LimitReached: true,
                    ButtonClicked: this.undoRedoButtonClicked,
                    KeyboardUsed: !this.undoRedoButtonClicked,
                };
                this.trackBlockRedo(true, trackingParameter);
                this.redoLimitExceededToastIsOn = true;
                setTimeout(() => { this.redoLimitExceededToastIsOn = false; }, 3000);
            }
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.UndoRedoService.unlock();
        }
    }
    replaceSpecialChars(str) {
        return str
            .replace(/[áàâã]/g, 'a')
            .replace(/[éèê]/g, 'e')
            .replace(/[íìî]/g, 'i')
            .replace(/[óòûõ]/g, 'o')
            .replace(/[úùû]/g, 'u')
            .replace(/[ç]/g, 'c');
    }
    matchInput(value = '', input = '') {
        return value !== null &&
            this.replaceSpecialChars(value.toLowerCase()).indexOf(input) !== -1;
    }
    matchTitle(title, input) {
        return this.matchInput(title, input);
    }
    matchTags(tags = [], input) {
        return tags.some((t) => this.matchInput(t.label, input));
    }
    matchOutputs(conditionOutputs = [], input) {
        return conditionOutputs.some((output) => {
            const answer = output.conditions.some((condition) => {
                if (condition.variable &&
                    this.matchInput(condition.variable, input)) {
                    return true;
                }
                else if (condition.values) {
                    return condition.values.some((val) => this.matchInput(val, input));
                }
                return false;
            });
            return answer;
        });
    }
    matchActions(customActions, input) {
        return customActions.some((action) => {
            if (this.matchInput(action.$title, input)) {
                return true;
            }
            else {
                try {
                    const pt1 = '"(listName|body|uri|variable|value|responseStatusVariable|responseBodyVariable|category|action|name|to|email|city|phoneNumber|address|source|outputVariable|inputVariables")":"[^"]*?';
                    const pt2 = '[^"]*?"';
                    const reg = new RegExp(pt1 + input + pt2, 'gi');
                    const actionString = this.replaceSpecialChars(JSON.stringify(action));
                    const result = reg.test(actionString);
                    return result;
                }
                catch (error) {
                    console.error(error);
                    return false;
                }
            }
        });
    }
    matchContent(contentActions, input) {
        return contentActions.some((content) => {
            const settings = content.action
                ? content.action.settings
                : undefined;
            if (settings &&
                settings.type !== 'application/vnd.lime.chatstate+json') {
                const content = settings.content || settings.rawContent;
                if (settings.type === 'text/plain') {
                    return this.matchInput(content, input);
                }
                else {
                    try {
                        const contentString = this.replaceSpecialChars(JSON.stringify(content));
                        const pt1 = '"(content|rawContent|value|title|text|uri|previewUri|previewText|label)":"[^"]*?';
                        const pt2 = '[^"]*?"';
                        const reg = new RegExp(pt1 + input + pt2, 'gi');
                        const result = reg.test(contentString);
                        return result;
                    }
                    catch (error) {
                        console.error(error);
                        return false;
                    }
                }
            }
        });
    }
    clearSearch() {
        this.$scope.$broadcast('TOGGLE_SEARCH', { showSearch: false });
    }
    makeSearch({ input }) {
        input = this.replaceSpecialChars(input.toLowerCase());
        if (!input) {
            this.$timeout(() => {
                this.searchedStates = [];
            });
            return;
        }
        const re = new RegExp(/(title|tags|content|actions|output):(.*)+/g);
        if (this.cachedSearchResults[input]) {
            this.searchedStates = this.cachedSearchResults[input];
            this.trackFlowSearched(input, re.exec(input), this.isBuilderLockedForEdit());
        }
        else {
            // const re = new RegExp(/([^ ]+):(.*)+/g);
            const searchScope = re.exec(input);
            if (!searchScope) {
                this.searchedStates = Object.keys(this.flow).reduce((states, s) => {
                    if (this.matchTitle(this.flow[s].$title, input) ||
                        this.matchTags(this.flow[s].$tags, input) ||
                        this.matchOutputs(this.flow[s].$conditionOutputs, input) ||
                        this.matchActions([
                            ...this.flow[s].$enteringCustomActions,
                            ...this.flow[s].$leavingCustomActions,
                        ], input) ||
                        this.matchContent(this.flow[s].$contentActions, input)) {
                        return [...states, s];
                    }
                    else {
                        return states;
                    }
                }, []);
                this.trackFlowSearched(input, searchScope, this.isBuilderLockedForEdit());
            }
            else {
                const scope = searchScope[1];
                const searchVal = searchScope[2].trim();
                const selectMatchFunc = (scope, searchVal) => (state) => {
                    switch (scope) {
                        case 'title':
                            return this.matchTitle(this.flow[state].$title, searchVal);
                        case 'tags':
                            return this.matchTags(this.flow[state].$tags, searchVal);
                        case 'content':
                            return this.matchContent(this.flow[state].$contentActions, searchVal);
                        case 'actions':
                            return this.matchActions([
                                ...this.flow[state].$enteringCustomActions,
                                ...this.flow[state].$leavingCustomActions,
                            ], searchVal);
                        case 'output':
                            return this.matchOutputs(this.flow[state].$conditionOutputs, searchVal);
                    }
                };
                const matchFunc = selectMatchFunc(scope, searchVal);
                this.searchedStates =
                    input.length > 0
                        ? Object.keys(this.flow).reduce((states, s) => {
                            if (matchFunc(s)) {
                                return [...states, s];
                            }
                            else {
                                return states;
                            }
                        }, [])
                        : [];
                this.trackFlowSearched(input, searchScope, this.isBuilderLockedForEdit());
            }
            this.$timeout(() => {
                this.cachedSearchResults[input] = this.searchedStates;
            });
        }
    }
    isSearched(id) {
        return this.searchedStates.includes(id);
    }
    containsSubFlowInSelection() {
        const selectedNodes = this.selectedNodes?.map(n => (typeof n === 'string' ? n : n.id));
        if (!selectedNodes) {
            return false;
        }
        return selectedNodes.some((item) => item.includes(SUBFLOW_ID_PREFIX));
    }
    keyboardListener(event) {
        const { keyCode, ctrlKey, metaKey, shiftKey } = event;
        this.segmentPayload = {};
        if (!(event instanceof KeyboardEvent)) {
            return;
        }
        // Some screen states will disable all keyboard actions,
        // like a modal being opened, for instance.
        if (!this.areKeyboardActionsEnabled) {
            return;
        }
        switch (keyCode) {
            case 13: // Enter
                if (event.altKey) {
                    this.toggleFullscreen();
                }
                break;
            case 46: //DELETE
                this.segmentPayload = { NumberOfBlocks: this.selectedNodes.length };
                if (!this.containsSubFlowInSelection()) {
                    this.deleteSelectedState();
                }
                else {
                    this.subFlowDeleteAlert();
                }
                break;
            case 27: //ESC
                if (!this.isCloseScriptTabEnabled &&
                    document.activeElement?.parentElement?.parentElement?.classList?.contains('monaco-editor')) {
                    return;
                }
                if (this.isCloseScriptTabEnabled &&
                    document.getElementsByClassName('monaco-editor').length > 0) {
                    return;
                }
                if (this.SidebarContentService.openSidebars.length > 0) {
                    this.closeSidebar();
                    this.deselectAllNodes();
                }
                else {
                    this.clearSearch();
                }
                break;
            case 67: //CTRL + C
                if (ctrlKey ||
                    (metaKey && navigator.userAgent.indexOf('Mac OS X') !== -1)) {
                    // Only copies states if no text is selected.
                    // When selecting nodes, all text will be deselected.
                    const isTextSelected = !!window.getSelection().toString();
                    if (!isTextSelected && this.selectedNodes.length) {
                        this.copySelectedToClipboard();
                    }
                }
                break;
            case 86: //CTRL + V - dont paste if is focused on a input element
                if ((ctrlKey ||
                    (metaKey &&
                        navigator.userAgent.indexOf('Mac OS X') !== -1)) &&
                    (document.activeElement.nodeName !== 'TEXTAREA' &&
                        document.activeElement.nodeName !== 'INPUT')) {
                    this.duplicateUndoRedoStateLocal();
                }
                break;
            case 80: // CTRL + P
                if (ctrlKey ||
                    (metaKey && navigator.userAgent.indexOf('Mac OS X') !== -1)) {
                    event.preventDefault();
                    this.publish();
                }
                break;
            case 70: // CTRL + SHIFT + F
                if ((ctrlKey ||
                    (metaKey &&
                        navigator.userAgent.indexOf('Mac OS X') !== -1)) &&
                    shiftKey) {
                    const searchBtn = document.querySelector('#search-tooltip button');
                    searchBtn && searchBtn.click();
                }
                break;
            default:
                break;
        }
    }
    /**
     * Try get a write lock for editing the flow.
     */
    async tryGetWriteLock(firstAttempt = false) {
        const lockImpl = this.getLockImplementation();
        try {
            // Try create a expirable lock for the current session.
            this.isWriteMode = await this.BuilderService.tryLockFlow(lockImpl, this.application.shortName, 60000);
            if (this.isWriteMode) {
                // If is the first time to acquire the lock, register the event listeners to release the lock
                // and receive write lock requests from other nodes.
                if (firstAttempt) {
                    const $scope = this.$scope;
                    const registerLockRequestListenerRegistration = this.BuilderService.registerLockRequestListener(lockImpl, this.application.shortName, async (requirerNode, force) => {
                        $scope.$apply();
                        return await this.showWriteLockRequestModal(requirerNode, force);
                    });
                    this.$scope.$on('$destroy', async () => {
                        registerLockRequestListenerRegistration();
                        await this.cancelWriteLockLoop();
                        if (this.isWriteMode) {
                            await this.BuilderService.releaseLock(lockImpl, this.application.shortName);
                        }
                    });
                }
                // Schedule to retrieve the lock again before expiration.
                // The interval is randomized to avoid 'lock check synchronization' between two sessions.
                let delay;
                if (firstAttempt) {
                    // In the first attempt, reduce the delay to avoid problems with concurrent lock,
                    // since the bucket do not provide real locking mechanisms.
                    delay = 5000 + Math.floor(Math.random() * 1000);
                }
                else {
                    delay = 45000 + Math.floor(Math.random() * 10000);
                }
                // Create a loop to keep the lock
                this.writeLockLoopPromise = this.$timeout(async () => await this.tryGetWriteLock(false), delay);
            }
            else {
                // Work in readonly mode
                this.writeLockNode = await this.BuilderService.getLockNode(lockImpl, this.application.shortName);
                await this.cancelWriteLockLoop();
            }
            this.hasLockRequestFailed = false;
        }
        catch (e) {
            this.hasLockRequestFailed = true;
            this.isWriteMode = false;
            const requestWriteLockError = await this.$translate('builder.requestWriteLockError');
            this.ngToast.danger(requestWriteLockError);
            console.error('[Builder] Failed to request write lock:', e);
        }
    }
    async cancelWriteLockLoop() {
        if (this.writeLockLoopPromise) {
            await this.$timeout.cancel(this.writeLockLoopPromise);
            this.writeLockLoopPromise = undefined;
        }
    }
    /**
     * This method is called when other session requests the write lock in the flow.
     * @param requestNode
     * @param timeout
     */
    async showWriteLockRequestModal(requestNode, force) {
        let modal;
        // Force is true if it is the same user that is requesting the control
        if (!force) {
            const transferLock = await this.$translate('builder.transferLock');
            const requestEmail = decodeURIComponent(requestNode.split('@')[0]);
            const transferLockRequest = await this.$translate('builder.transferLockRequest', { name: requestEmail });
            const cancel = await this.$translate('utils.forms.cancel');
            modal = await this.ModalService.showModal(ConfirmationModal({
                title: {
                    text: transferLock,
                },
                body: transferLockRequest,
                buttons: {
                    confirm: {
                        text: transferLock,
                    },
                    cancel: {
                        text: cancel,
                    },
                },
            }));
        }
        if (force || (await modal.close)) {
            this.trackWriteReleased();
            await this.debouncedSave();
            this.isWriteMode = false;
            this.writeLockNode = requestNode;
            await this.cancelWriteLockLoop();
            return true;
        }
        return false;
    }
    /**
     * Requires to other session the write lock for the current flow.
     */
    async requestWriteLockModal() {
        // Check again if we can have the write lock
        try {
            this.isWriteMode = await this.BuilderService.tryLockFlow(this.getLockImplementation(), this.application.shortName, 60000);
            if (this.isWriteMode) {
                this.$state.reload();
                return;
            }
        }
        catch (e) {
            const requestWriteLockError = await this.$translate('builder.requestWriteLockError');
            this.ngToast.danger(requestWriteLockError);
            this.isWriteMode = false;
            console.error(e);
            return;
        }
        this.trackWriteRequest();
        const writeLockEmail = decodeURIComponent(this.writeLockNode.split('@')[0]);
        const currentEmail = decodeURIComponent(this.BlipService.localNode.split('@')[0]);
        const requestToEdit = await this.$translate('builder.requestToEdit');
        const cancel = await this.$translate('utils.forms.cancel');
        let confirm;
        let requestWriteLock;
        let force;
        // Check if is the same user that is editing the flow
        if (writeLockEmail == currentEmail) {
            force = true;
            requestWriteLock = await this.$translate('builder.sameUserRequestWriteLock');
            confirm = await this.$translate('utils.misc.yes');
        }
        else {
            force = false;
            requestWriteLock = await this.$translate('builder.requestWriteLock', { name: writeLockEmail });
            confirm = requestToEdit;
        }
        const modal = await this.ModalService.showModal(ConfirmationModal({
            title: {
                text: requestToEdit,
            },
            body: requestWriteLock,
            buttons: {
                confirm: {
                    text: confirm,
                },
                cancel: {
                    text: cancel,
                },
            },
        }));
        if (await modal.close) {
            this.isRequestingLock = true;
            try {
                // Check again for the lock. This avoid sending the request to the wrong bot in case the user has changed bots
                // while the modal is presented.
                const currentNode = await this.BuilderService.getLockNode(this.getLockImplementation(), this.application.shortName);
                const isReleased = !currentNode || currentNode == this.BlipService.localNode;
                if (isReleased ||
                    await this.BuilderService.requestLock(this.writeLockNode, force, 60000)) {
                    // Lock granted
                    const writeLockGranted = await this.$translate('builder.writeLockGranted');
                    this.ngToast.success(writeLockGranted);
                    this.BuilderSegmentService.trackWriteLockGranted();
                    this.$state.reload();
                }
                else {
                    // Lock denied
                    const writeLockDenied = await this.$translate('builder.writeLockDenied', { name: writeLockEmail });
                    this.ngToast.warning(writeLockDenied);
                    this.BuilderSegmentService.trackWriteLockDenied();
                }
            }
            finally {
                this.isRequestingLock = false;
            }
        }
    }
    async updateExecuteScriptActions() {
        for (const prop in this.flow) {
            if (this.flow.hasOwnProperty(prop)) {
                [...this.flow[prop].$enteringCustomActions,
                    ...this.flow[prop].$leavingCustomActions].map((act) => {
                    if (act.type == executeScriptActionType) {
                        act.settings.LocalTimeZoneEnabled = this.isLocalTimezoneEnabled;
                    }
                });
            }
        }
    }
    async publish() {
        await this.checkTemplateHostingMessageReceiverVersion();
        this.clearSearch();
        let isValid = false;
        let isValidToPublishFlow = false;
        const statusBeforePublished = this.application.status;
        //setup enabledEngine feature toggle for execute script actions (delete afterwards)
        await this.updateExecuteScriptActions();
        this.isPublishing = true;
        const publishStartTime = new Date();
        try {
            if (!(await this.ChatbotSettingsService.isBuilderActive(this.application))) {
                const errorMsg105 = this.$translate.instant('utils.errorMsg.114');
                this.ngToast.warning(errorMsg105);
                this.trackFlowPublished(false, 'Builder disabled Error');
                return;
            }
            try {
                this.flowViewModelValidator.validate(this.flow);
                this.globalStateViewModelValidator.validate(this.globalActions);
                if (this.application.isSubflow) {
                    this.subflowViewModelValidator.validate(this.flow);
                }
                else {
                    isValidToPublishFlow = await this.validateSubflowToPublishing();
                }
                isValid = true;
            }
            catch (e) {
                console.error(e);
                const errorMsg105 = this.$translate.instant('utils.errorMsg.105');
                this.ngToast.warning(errorMsg105);
                this.trackFlowPublishedValidationErrorMessages(this.application.isSubflow, e.message);
            }
            if (isValid) {
                try {
                    let successMsg;
                    if (this.application.isSubflow) {
                        await this.BuilderService.publishSubFlow(this.application, this.flow, this.configuration, this.flowId);
                        this.trackSubFlowPublished(true);
                        successMsg = await this.$translate('utils.successMsg.46');
                        this.BlipToastService.show(ToastType.Success, {
                            msg: successMsg,
                        });
                    }
                    else {
                        this.configuration[EngineLocaltimezoneKey] = this.account.timeZoneName || SouthAmericaTimezone;
                        if (isValidToPublishFlow) {
                            await this.BuilderService.publishFlow(this.flow, this.configuration, this.globalActions, this.application, this.flowId, undefined);
                            if (this.isBuilderSecretConfigurationEnabled &&
                                this.isChangeSecretConfiguration()) {
                                await this.BuilderService.setSecretConfigurationOnVault(this.secretConfiguration);
                                this.secretConfigurationCurrentItems = { ...this.secretConfiguration };
                            }
                            this.trackFlowPublished(true);
                            successMsg = await this.$translate('utils.successMsg.28');
                            this.ngToast.success(successMsg);
                        }
                    }
                }
                catch (e) {
                    console.error(e);
                    this.trackFlowPublishedBackendValidationErrorMessages(this.application.isSubflow, e.description);
                    if (e instanceof ValidationError) {
                        const errorMsg105 = this.$translate.instant('utils.errorMsg.105');
                        this.ngToast.warning(errorMsg105);
                    }
                    else if (e.description) {
                        this.validateSubflowAccessWhenPublishing(e);
                        const loopErrorRegex = /There is a loop in the flow starting in the state ([0-9\w\-]+) that does not requires user input/;
                        const match = loopErrorRegex.exec(e.description);
                        if (match?.length > 1) {
                            const loopStateId = match[1];
                            const loopState = this.flow[loopStateId];
                            loopState.$invalid = true;
                            const errorMsg107 = await this.$translate('utils.errorMsg.111');
                            this.ngToast.danger(errorMsg107);
                        }
                        else {
                            const errorMsg107 = await this.$translate('utils.errorMsg.107');
                            this.ngToast.danger(errorMsg107);
                            console.error(e);
                        }
                    }
                    else {
                        const errorMsg107 = await this.$translate('utils.errorMsg.107');
                        this.ngToast.danger(errorMsg107);
                        console.error(e);
                    }
                }
            }
        }
        finally {
            if (!this.application.isSubflow && (!statusBeforePublished || statusBeforePublished === 'offline')) {
                this.$state.reload();
            }
            this.enablePublishButton(publishStartTime);
        }
    }
    enablePublishButton(publishStartTime) {
        const publishTime = new Date().getTime() - publishStartTime.getTime();
        if (publishTime < BUILDER_PUBLISH_DEBOUNCE_TIME) {
            this.$timeout(() => {
                this.isPublishing = false;
            }, 2000 - publishTime);
        }
        else {
            this.isPublishing = false;
        }
    }
    validateSubflowAccessWhenPublishing(e) {
        const subflowAccessErroRegex = /The current identity doesn't have the required permission to access subflow/;
        if (subflowAccessErroRegex.test(e.description)) {
            const errorMsg179 = this.$translate.instant('utils.errorMsg.179');
            this.ngToast.danger(errorMsg179);
        }
    }
    setupGrapToPan(canvas) {
        this.g2p = new GrabToPan({
            element: canvas,
            onActiveChanged: () => { },
        });
        this.g2p.ignoreTarget = (node) => {
            return node.classList.contains('grabbable') ? false : true;
        };
        this.g2p.activate();
    }
    setupJsPlumb(canvas) {
        this.builderInstance = this.JsPlumbService.createInstance(canvas);
        this.builderInstance.batch(() => {
            this.setConectionsListeners();
        }, true);
    }
    setBuilderZoom() {
        this.zoomSlider = {
            value: 100,
            options: {
                floor: 20,
                ceil: 100,
                step: 1,
                hidePointerLabels: true,
                hideLimitLabels: true,
            },
        };
        this.$scope.$watch('$ctrl.zoomSlider.value', (newValue) => {
            this.setZoomValue(newValue);
            this.zoomValue = newValue;
        });
    }
    setScrollListener(canvas) {
        const scrollListener = (event) => {
            if (event.ctrlKey || event.metaKey) {
                event.preventDefault();
                let zoomVal = this.zoomSlider.value;
                if (event.deltaY > 0) {
                    zoomVal = zoomVal - 10 <= 20 ? 20 : zoomVal - 10;
                    this.$timeout(() => {
                        this.zoomSlider.value = zoomVal;
                    }, 0);
                }
                else {
                    zoomVal = zoomVal + 10 >= 100 ? 100 : zoomVal + 10;
                    this.$timeout(() => {
                        this.zoomSlider.value = zoomVal;
                    }, 0);
                }
                return false;
            }
        };
        canvas.addEventListener('wheel', scrollListener, { passive: false });
        this.$scope.$on('$destroy', () => canvas.removeEventListener('wheel', scrollListener));
    }
    setZoomValue(value) {
        const zoomVal = value / 100;
        const canvas = document.getElementById('diagramContainer');
        canvas.style.transform = `scale(${zoomVal})`;
        canvas.style.transformOrigin = `calc(500% / (100 - ${zoomVal}/2) ) calc(500% / (100 - ${zoomVal}/2) )`;
        this.builderInstance.setZoom(zoomVal);
    }
    toggleZoom() {
        this.isZoomOpen = !this.isZoomOpen;
    }
    fillStateViewProperties(state) {
        // If there's already, ignores
        if ((state.$position || state.$title)) {
            this.addTagsFromState(state);
            return state;
        }
        const newState = {
            ...state,
            $position: {
                top: '120px',
                left: '1px',
            },
        };
        switch (newState.id) {
            case STATE_ID_ONBOARDING:
                newState.$title = this.$translate.instant('builder.node.onboardingTitle');
                newState.$position.left = '644px';
                break;
            case STATE_ID_FALLBACK:
                newState.$title = this.$translate.instant('builder.node.fallbackTitle');
                newState.$position.left = '877px';
                break;
            case STATE_ID_WELCOME:
                newState.$title = this.$translate.instant('builder.node.welcomeBlockTitle');
                newState.$position.top = '240px';
                newState.$position.left = '644px';
                break;
            case STATE_ID_ERROR:
                newState.$title = this.$translate.instant('builder.node.errorBlockTitle');
                newState.$position.top = '240px';
                newState.$position.left = '877px';
                break;
            case STATE_ID_END:
                newState.$title = this.$translate.instant('builder.node.subflow.endBlockTitle');
                newState.$position.left = '1110px';
                break;
            case STATE_ID_FIRST_BLOCK_SUBFLOW:
                newState.$title = this.$translate.instant('builder.node.subflow.firstBlockTitle');
                newState.$position.top = '240px';
                newState.$position.left = '644px';
                break;
        }
        return newState;
    }
    addTagsFromState(state) {
        if (state.$tags) {
            state.$tags.map((t) => {
                if (!this.TagsService.tags.some((existingTag) => existingTag.label === t.label)) {
                    this.TagsService.tags = this.TagsService.tags.concat(t);
                }
            });
        }
    }
    setConectionsListeners() {
        //new connection
        this.builderInstance.bind('connection', (info) => {
            const allConns = this.builderInstance.getConnections({
                source: info.sourceId,
                target: info.targetId,
            });
            if (allConns.length > 1) {
                this.isCleaning = true;
                const connObj = allConns.find((c) => c.id == info.connection.id);
                this.builderInstance.deleteConnection(connObj);
            }
            this.hasOldConn = false;
        });
        this.builderInstance.bind('connectionDetached', (info) => {
            let oldOutput;
            let outputIndex;
            if (!this.isBinding && !this.isCleaning) {
                try {
                    const state = this.flow[info.sourceId];
                    // Check if is a condition output or a desk output
                    outputIndex = state.$conditionOutputs.findIndex((o) => o.stateId == info.targetId);
                    if (outputIndex >= 0) {
                        oldOutput = state.$conditionOutputs[outputIndex];
                        const output = state.$conditionOutputs[outputIndex];
                        if (output.$isDeskOutput || output.$isSmartSalesOutput) {
                            output.stateId = undefined;
                        }
                        else {
                            // Delete the output from the state
                            state.$conditionOutputs.splice(outputIndex, 1);
                        }
                    }
                }
                catch (e) {
                    console.error(e);
                }
            }
            else {
                if (this.isCleaning) {
                    this.isCleaning = false;
                }
            }
            if (this.isBuilderUndoRedoOutputsEnabled && !this.isBinding) {
                if (oldOutput?.conditions && document.getElementById(info.sourceId)) {
                    const cardContentIAction = new CardOutputContentIAction({
                        data: {
                            state: {
                                id: angular.copy(this.flow[info.sourceId].id),
                                $title: angular.copy(this.flow[info.sourceId].$title),
                            },
                            newOutput: info.targetId,
                        },
                        execute: async () => {
                            if (oldOutput.$isSmartSalesOutput || oldOutput.$isDeskOutput) {
                                this.flow[info.sourceId].$conditionOutputs[outputIndex].stateId = undefined;
                                try {
                                    this.validateState(this.flow[info.sourceId]);
                                    this.flow[info.sourceId].$invalid = false;
                                }
                                catch (e) {
                                    this.flow[info.sourceId].$invalid = true;
                                }
                                this.bindStateConnections(info.sourceId);
                                return;
                            }
                            const target = this.flow[info.sourceId].$conditionOutputs[outputIndex]?.stateId;
                            if (target) {
                                await this.onOutputChange(this.flow[info.sourceId], this.flow[info.sourceId].$conditionOutputs[outputIndex], target);
                                this.debouncedSave();
                            }
                        },
                        undo: () => {
                            if (oldOutput.$isSmartSalesOutput || oldOutput.$isDeskOutput) {
                                const oldConditionsInString = JSON.stringify(oldOutput.conditions);
                                this.flow[info.sourceId].$conditionOutputs = this.flow[info.sourceId].$conditionOutputs.map(currentCondition => {
                                    const currentConditionsInString = JSON.stringify(currentCondition.conditions);
                                    if (currentConditionsInString !== oldConditionsInString) {
                                        return currentCondition;
                                    }
                                    return {
                                        ...oldOutput,
                                        stateId: info.targetId,
                                    };
                                });
                                try {
                                    this.validateState(this.flow[info.sourceId]);
                                    this.flow[info.sourceId].$invalid = false;
                                }
                                catch (e) {
                                    this.flow[info.sourceId].$invalid = true;
                                }
                                this.bindStateConnections(info.sourceId);
                                return;
                            }
                            const currentEditingState = angular.copy(this.flow[info.sourceId]);
                            const output = OutputViewModel.create(info.targetId, info.connId, uuid());
                            output.conditions = oldOutput.conditions;
                            output.order = oldOutput.order;
                            builderStore.setState({
                                ...currentEditingState,
                                $conditionOutputs: immutableSplice(this.flow[info.sourceId].$conditionOutputs, outputIndex, 0, output),
                            });
                        },
                    });
                    this.UndoRedoService.add(cardContentIAction);
                }
            }
        });
        this.builderInstance.bind('beforeDrop', (info) => {
            const connId = info.connection.id;
            const rebuildConnection = (connection, target) => {
                const connSource = Object.keys(this.flow).find(k => this.flow[k].$conditionOutputs.find((out) => out.$connId == connId));
                const oldConnSource = angular.copy(connSource);
                if (!oldConnSource) {
                    return false;
                }
                this.$timeout(() => {
                    this.builderInstance.deleteConnection(connection);
                    const newConnId = this.builderInstance.connect(connectionStyle(oldConnSource, target)).id;
                    this.flow[oldConnSource].$conditionOutputs
                        .find(co => co.$connId === connId)
                        .$connId = newConnId;
                }, 1);
                return true;
            };
            if (this.flow[info.sourceId].$conditionOutputs.length > 24) {
                const errorMsg = this.$translate.instant('builder-tabs-outputs.limitReached');
                this.ngToast.danger(errorMsg);
                return rebuildConnection(info.connection, info.targetId);
            }
            if (info.connection.suspendedElementType === 'source') {
                const errorMsg108 = this.$translate.instant('utils.errorMsg.108');
                this.ngToast.danger(errorMsg108);
                return rebuildConnection(info.connection, info.targetId);
            }
            const currentConn = this.flow[info.sourceId].$conditionOutputs.find((out) => out.$connId == connId);
            if (currentConn) {
                const result = this.moveConnection(info.sourceId, info.targetId, currentConn);
                return result;
            }
            else {
                const result = this.createNewConnection(info.sourceId, info.targetId, info.connection.id);
                return result;
            }
        });
    }
    createNewConnection(sourceId, targetId, connId) {
        if (sourceId === STATE_ID_END) {
            const errorMsg178 = this.$translate.instant('utils.errorMsg.178');
            this.ngToast.danger(errorMsg178);
            return;
        }
        const allConns = this.builderInstance.getConnections({
            source: sourceId,
            target: targetId,
        });
        const output = OutputViewModel.create(targetId, connId, uuid());
        const currentEditingState = angular.copy(this.flow[sourceId]);
        builderStore.setState({
            ...currentEditingState,
            $conditionOutputs: this.flow[sourceId].$conditionOutputs.concat(output),
        });
        if (this.isBuilderUndoRedoOutputsEnabled) {
            const cardOutputContentIAction = new CardOutputContentIAction({
                data: {
                    state: {
                        id: angular.copy(this.flow[sourceId].id),
                        $title: angular.copy(this.flow[sourceId].$title),
                    },
                },
                execute: () => {
                    const outputFromAction = OutputViewModel.create(targetId, connId, output.$id);
                    const currentEditingState = angular.copy(this.flow[sourceId]);
                    builderStore.setState({
                        ...currentEditingState,
                        $conditionOutputs: this.flow[sourceId].$conditionOutputs.concat(outputFromAction),
                    });
                },
                undo: async () => {
                    const conditionOutputIndex = angular.copy(this.flow[sourceId].$conditionOutputs).length - 1;
                    const target = this.flow[sourceId].$conditionOutputs[conditionOutputIndex].stateId;
                    await this.onOutputChange(this.flow[sourceId], output, target);
                    this.debouncedSave();
                },
            });
            this.UndoRedoService.add(cardOutputContentIAction);
        }
        this.debouncedSave();
        return allConns.length == 0 ? true : false;
    }
    moveConnection(sourceId, newTargetId, currentConn) {
        const oldTarget = currentConn.stateId;
        const changedOutputs = {};
        this.flow[sourceId].$conditionOutputs.forEach((output) => {
            if (output.stateId == oldTarget) {
                output.stateId = newTargetId;
                changedOutputs[output.$id] = true;
            }
        });
        this.debouncedSave();
        this.hasOldConn = true;
        if (this.isBuilderUndoRedoOutputsEnabled) {
            const cardContentIAction = new CardOutputContentIAction({
                data: {
                    state: {
                        id: angular.copy(this.flow[sourceId].id),
                        $title: angular.copy(this.flow[sourceId].$title),
                    },
                },
                execute: () => {
                    this.flow[sourceId].$conditionOutputs
                        .filter(output => changedOutputs[output.$id])
                        .forEach(async (output) => {
                        if (output.stateId == oldTarget) {
                            output.stateId = newTargetId;
                        }
                        this.onOutputChange(this.flow[sourceId], output, newTargetId, oldTarget);
                    });
                    this.debouncedSave();
                    this.hasOldConn = true;
                },
                undo: () => {
                    this.flow[sourceId].$conditionOutputs
                        .filter(output => changedOutputs[output.$id])
                        .forEach(async (output) => {
                        if (output.stateId == newTargetId) {
                            output.stateId = oldTarget;
                        }
                        await this.onOutputChange(this.flow[sourceId], output, oldTarget, newTargetId);
                    });
                    this.debouncedSave();
                    this.hasOldConn = true;
                },
            });
            this.UndoRedoService.add(cardContentIAction);
        }
        return true;
    }
    createConnections() {
        //Create connections programmatically only if is the first loop
        if (!this.isFirstLoop) {
            return;
        }
        for (const stateId in this.flow) {
            if (stateId) {
                this.bindStateConnections(stateId);
            }
        }
    }
    createConnectionsForState(stateId) {
        if (this.flow[stateId]) {
            this.bindStateConnections(stateId);
        }
    }
    makeConnectionToast(message) {
        const newOutputMsg = this.$translate.instant(message);
        this.ngToast.create({
            className: 'success',
            content: newOutputMsg,
            dismissOnTimeout: true,
            timeout: 1000,
        });
    }
    clearNodeConnections(source, target, output) {
        if (target == undefined) {
            return;
        }
        const options = { source, target };
        const conns = this.builderInstance.getConnections(options);
        conns.forEach((element) => {
            if (output) {
                this.builderInstance.deleteConnection(element);
            }
        });
    }
    async removeUnnecessaryConnection(stateId) {
        try {
            const hasDraw = [];
            const conns = this.builderInstance.getConnections({
                source: stateId,
            });
            conns.reverse().forEach((conn) => {
                const drawConn = hasDraw.find((c) => conn.targetId == c.targetId);
                if (drawConn) {
                    this.isCleaning = true;
                    this.builderInstance.deleteConnection(conn);
                }
                else {
                    hasDraw.push(conn);
                }
            });
        }
        catch (e) {
            this.isCleaning = false;
            console.error(e);
        }
    }
    async redrawOldConnection(source, target) {
        try {
            this.isCleaning = true;
            const options = { source, target };
            const conns = this.builderInstance.getConnections(options);
            if (conns.length == 0) {
                const outputIndex = this.flow[source].$conditionOutputs.findIndex((c) => c.stateId === target);
                if (outputIndex >= 0) {
                    const connObj = this.builderInstance.connect(connectionStyle(source, target));
                    this.flow[source].$conditionOutputs[outputIndex].$connId =
                        connObj.id;
                }
            }
        }
        finally {
            this.isCleaning = false;
        }
    }
    // Set states connections. If has one duplicated, remove it.
    bindStateConnections(stateId) {
        this.isBinding = true;
        try {
            const state = this.flow[stateId];
            if (state) {
                const currentConnections = this.builderInstance.getConnections({ source: stateId });
                currentConnections.filter(conn => state.$conditionOutputs.every(co => co.stateId !== conn.targetId))
                    .forEach(conn => this.builderInstance.deleteConnection(conn));
                state.$conditionOutputs
                    .filter(co => co && co.stateId !== undefined && !co.$isDeskDefaultOutput && !co.$isAgentDefaultOutput)
                    .forEach((conn) => {
                    if (!conn.$id) { // Used to identify old outputs connections #206378
                        conn.$id = uuid();
                    }
                    const sourceElement = document.getElementById(state.id);
                    const targetElement = document.getElementById(conn.stateId);
                    if (targetElement && currentConnections.every((c) => c.id !== conn.$connId)) {
                        const connObj = this.builderInstance.connect(connectionStyle(sourceElement, targetElement));
                        conn.$connId = connObj.id;
                        this.removeUnnecessaryConnection(stateId);
                    }
                });
            }
        }
        finally {
            this.isBinding = false;
        }
    }
    checkNegative(position) {
        const value = Number(position.split('px')[0]) || 0;
        return value > 0 ? value + 'px' : '0px';
    }
    /**
     * Create node element for state object
     * @param state
     */
    createStateNode(state) {
        this.$timeout(() => {
            const nodeElement = document.getElementById(state.id);
            if (!nodeElement) {
                return;
            }
            nodeElement.style.left = this.checkNegative(state.$position.left);
            nodeElement.style.top = this.checkNegative(state.$position.top);
            this.builderInstance.draggable(nodeElement, {
                containment: true,
            });
            this.builderInstance.makeSource(nodeElement, {
                filter: '.diagram-node-endpoint',
                anchor: 'Continuous',
                connectorStyle: {
                    stroke: DEFAULT_CONNECTOR_COLOR,
                    strokeWidth: 2,
                    outlineStroke: 'transparent',
                    outlineWidth: 4,
                },
                Endpoint: ['Dot', { radius: 15 }],
                endpointStyle: { fill: 'transparent' },
                connectionType: 'basic',
                extract: {
                    action: 'the-action',
                },
                maxConnections: -1,
                dropOptions: {
                    drop: () => { },
                },
            });
            this.builderInstance.makeTarget(nodeElement, {
                dropOptions: { hoverClass: 'selected-node' },
                anchor: 'Continuous',
                Endpoint: ['Dot', { radius: 15 }],
                endpointStyle: { fill: 'transparent' },
                allowLoopback: true,
            });
            this.addNodeListeners(nodeElement);
            // If the state has been pasted, select it so the user can easily move it.
            if (this.isBuilderImprovedCopyPasteFeatureEnabled && this.pastedStates.includes(state.id)) {
                this.selectNode(nodeElement, false);
                this.builderInstance.addToDragSelection(nodeElement);
            }
        });
    }
    async closeSidebar() {
        await this.SidebarContentService.cleanAndClose(false);
        if (!this.ChatService.built) {
            this.ChatService.build();
        }
    }
    addNodeListeners(node) {
        //dd listeners only if click on node or node-title
        let isDragging = false;
        let currHandleDragging;
        const handleDragging = (positions) => (event) => {
            if (positions.x !== event.x || positions.y !== event.y) {
                isDragging = true;
            }
        };
        node.addEventListener('click', (event) => {
            event.stopPropagation();
            this.ContextMenuService.close();
        });
        node.addEventListener('mousedown', (event) => {
            event.stopPropagation();
            if (event.button === RIGHT_CLICK_BUTTON) { // not right click
                return;
            }
            isDragging = false;
            currHandleDragging = handleDragging({ x: event.x, y: event.y });
            node.addEventListener('mousemove', currHandleDragging);
            if (!event.shiftKey && this.selectedNodes.length === 1) {
                this.deselectAllNodes();
                this.builderInstance.clearDragSelection();
            }
            const alreadySelected = !!this.selectedNodes.find((n) => n.id === node.id);
            if (alreadySelected) {
                this.deselectNode(node);
                this.builderInstance.removeFromDragSelection(node);
            }
            else {
                this.selectNode(node);
                this.builderInstance.addToDragSelection(node);
            }
        });
        node.addEventListener('mouseup', (event) => {
            this.segmentPayload = {}; //reseting the payload variable.
            if (!isDragging && !event.shiftKey) {
                const state = this.flow[node.id];
                if (this.isSubflowId(state.id) && this.isInnerStateElement(event.target)) {
                    return;
                }
                this.debouncedEditState(state);
                if (event.button !== RIGHT_CLICK_BUTTON && !this.ContextMenuService.isOpen()) {
                    this.deselectAllNodes();
                }
                this.selectNode(node);
                this.$scope.$apply();
            }
            node.removeEventListener('mousemove', currHandleDragging);
            const newPosition = { top: node.style.top, left: node.style.left };
            const curr = this.flow[node.id].$position;
            if (newPosition.left !== curr.left || newPosition.top !== curr.top) {
                const repositionNode = ({ id, nodePosition }) => {
                    this.flow[id].$position = { ...nodePosition };
                    const nodeElement = document.getElementById(id);
                    nodeElement.style.left = this.checkNegative(nodePosition.left);
                    nodeElement.style.top = this.checkNegative(nodePosition.top);
                };
                if (this.isUndoRedoBlockPositionEnabled) {
                    let moveStateActions = [];
                    this.selectedNodes.forEach((selectedNode) => {
                        const newNodePosition = {
                            top: selectedNode.style.top,
                            left: selectedNode.style.left,
                        };
                        const moveNodeIAction = new MoveStateIAction({
                            data: {
                                state: {
                                    id: selectedNode.id,
                                    $title: this.flow[selectedNode.id].$title,
                                },
                                node: selectedNode,
                                position: { ...this.flow[selectedNode.id].$position },
                                newPosition: newNodePosition,
                            },
                            execute: (data) => {
                                repositionNode({
                                    id: data.state.id,
                                    nodePosition: { ...data?.newPosition },
                                });
                            },
                            undo: (data) => {
                                repositionNode({
                                    id: data.state.id,
                                    nodePosition: { ...data?.position },
                                });
                            },
                        });
                        moveStateActions = [...moveStateActions, moveNodeIAction];
                        this.flow[selectedNode.id].$position = { ...newNodePosition };
                    });
                    const doAction = (actions, fn) => {
                        actions.forEach(action => {
                            fn(action);
                            this.builderInstance.revalidate(action.data.node);
                        });
                        this.debouncedSave();
                    };
                    //update segment payload var
                    if (moveStateActions.length != 0) {
                        this.segmentPayload = {
                            'Action': moveStateActions.length === 1 ? BUILDER_BLOCK_MOVE_STATE : BUILDER_BLOCK_MOVE_STATES,
                            'NumberOfBlocks': moveStateActions.length,
                        };
                    }
                    const moveNodesIAction = new MoveStatesIAction({
                        data: {
                            state: moveStateActions.length === 1 ? moveStateActions[0].data.state : { id: '', $title: '' },
                            actions: moveStateActions,
                        },
                        execute: ({ actions }) => {
                            doAction(actions, a => a.execute(a.data));
                        },
                        undo: ({ actions }) => {
                            doAction(actions, a => a.undo(a.data));
                        },
                    });
                    this.UndoRedoService.add(moveNodesIAction);
                }
                else {
                    // just change the position
                    this.selectedNodes.forEach((selectedNode) => {
                        const newNodePosition = {
                            top: selectedNode.style.top,
                            left: selectedNode.style.left,
                        };
                        this.flow[selectedNode.id].$position = { ...newNodePosition };
                    });
                }
            }
            this.debouncedSave();
        });
    }
    selectNode(node, exclusive = false) {
        if (!node) {
            return;
        }
        // Clear selected text
        window.getSelection().removeAllRanges();
        if (exclusive) {
            this.deselectAllNodes();
        }
        // Already selected
        if (this.selectedNodes.some(n => n.id == node.id)) {
            return;
        }
        this.selectedNodes.push(node);
        node.classList.add('selected-node');
        this.updateSelectedConns();
    }
    deselectAllNodes() {
        while (this.selectedNodes.length > 0) {
            this.deselectNode(this.selectedNodes[0]);
        }
        this.builderInstance.clearDragSelection();
    }
    deselectNode(node) {
        if (!node && typeof (node) !== 'object') {
            return;
        }
        this.selectedNodes = this.selectedNodes.removeItem(node);
        if (node.classList && node.classList.contains('selected-node')) {
            node.classList.remove('selected-node');
        }
        this.updateSelectedConns();
    }
    updateSelectedConns() {
        this.builderInstance.getConnections().forEach(conn => conn.removeType('selected'));
        let connsToBeSelected = [];
        this.selectedNodes.forEach(selectedNode => {
            const leavingConns = this.builderInstance.getConnections({
                source: selectedNode.id,
            });
            const incomingConns = this.builderInstance.getConnections({
                target: selectedNode.id,
            });
            connsToBeSelected = connsToBeSelected.concat(leavingConns);
            connsToBeSelected = connsToBeSelected.concat(incomingConns);
        });
        connsToBeSelected.forEach(conn => conn.addType('selected'));
    }
    isDefaultNode(stateId) {
        return stateId === STATE_ID_FALLBACK || stateId === STATE_ID_ONBOARDING || stateId === STATE_ID_END;
    }
    async addContentFromOutput({ state, label, output, oldTarget }) {
        const newState = this.createContentState(label);
        await this.createContentStateOnActions(newState, true);
        await this.onOutputChange(state, output, newState.id, oldTarget);
    }
    async addContentSurveyFromOutput({ state, template, output, oldTarget }) {
        let stateSurveyRoot = undefined;
        const statesToSave = SatisfactionSurveyModel.map((surveyState) => {
            if (this.isSurveyState(surveyState)) {
                surveyState.$title = template;
            }
            stateSurveyRoot = surveyState;
            return surveyState;
        });
        if (stateSurveyRoot) {
            await this.duplicateUndoRedoState(statesToSave, parseInt(state.$position.left.slice(0, -2), 10), parseInt(state.$position.top.slice(0, -2), 10));
            this.BuilderSegmentService.trackSatisfactionSurveyCreatedFromTemplate({
                output: output,
                template: template,
            });
            Object.keys(this.flow).forEach((key) => {
                if (key.startsWith(SURVEY_ID_PREFIX) && this.flow[key].hasOwnProperty('id')) {
                    this.onOutputChange(state, output, this.flow[key].id, oldTarget);
                    return;
                }
            });
        }
    }
    async createContentStateOnActions(state, fromOutput = false) {
        try {
            const addStateIAction = new AddStateIAction({
                data: {
                    state: {
                        $title: state.$title,
                        id: state.id,
                    },
                    ...state,
                },
                execute: async () => {
                    await this.addAndEditState(state);
                },
                undo: data => {
                    this.deleteSelectedState(data.id);
                },
            });
            this.UndoRedoService.add(addStateIAction);
            this.clearSearch();
            await this.addAndEditState(state, fromOutput);
            this.createBlockTracking('Content');
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.setAddingBlockValue(false);
        }
    }
    async addContentState() {
        const defaultTitle = await this.$translate('builder.node.defaultTitle');
        const state = this.createContentState(defaultTitle);
        await this.createContentStateOnActions(state);
    }
    async addSubflow() {
        this.setAddingBlockValue(false);
        if (await BuilderFeatures.hasPermissionToAccessRelease2OfSubflowEnabled()) {
            await this.showChooseOrCreateSubflowModal();
        }
        else {
            await this.showCreateOrUpdateSubflowModal(SubflowModalAction.Create);
        }
    }
    async editSubflow(state) {
        this.$timeout(async () => {
            await this.showCreateOrUpdateSubflowModal(SubflowModalAction.Update, state);
        });
        this.BuilderSegmentService.trackSubflowConfigurationOpened({
            SubflowID: state.id,
            SubflowName: state.$title,
        });
    }
    async showChooseOrCreateSubflowModal() {
        const modal = await this.ModalService.showModal(chooseOrCreateSubFlowModal({
            confirm: async (choose) => {
                await this.BuilderSegmentService.trackSubflowModelSelected(choose, this.application);
                if (!choose) {
                    await this.showCreateOrUpdateSubflowModal(SubflowModalAction.Create);
                }
            },
            whatIsSubflow: async () => {
                const learnMoreOfSubflowUrl = await this.$translate('builder.helpLink.whatIsSubflow');
                window.open(learnMoreOfSubflowUrl, 'blank');
                await this.BuilderSegmentService.trackWhatIsSubflowOpened({}, this.application);
            },
        }));
        return await modal.close;
    }
    /**
     * This method is called when create subflow its clicked.
     */
    async showCreateOrUpdateSubflowModal(action, state = undefined) {
        const shortNameOfSubflow = state ? state.shortNameOfSubflow : '';
        this.BuilderSegmentService.trackSubflowCreateModalOpened({ action, shortName: shortNameOfSubflow }, this.application);
        this.areKeyboardActionsEnabled = false;
        const modal = await this.ModalService.showModal(createSubFlowModal({
            action,
            shortName: shortNameOfSubflow,
            confirm: (subflow) => {
                subflow.tenantId = this.account?.extras.tenantId;
                subflow.isShared = false;
                subflow.userIdentity = this.account?.email;
                this.createOrUpdateSubflow(action, subflow, state);
            },
            whatIsSubflow: async () => {
                const learnMoreOfSubflowUrl = await this.$translate('builder.helpLink.whatIsSubflow');
                window.open(learnMoreOfSubflowUrl, 'blank');
                this.BuilderSegmentService.trackWhatIsSubflowOpened({}, this.application);
            },
        }));
        const confirmation = await modal.close;
        this.areKeyboardActionsEnabled = true;
        return confirmation;
    }
    async createOrUpdateSubflow(action, subflow, state = undefined) {
        if (!this.hasPermissionToAccessSubflow) {
            return;
        }
        try {
            const newSubflow = action === SubflowModalAction.Create
                ? await this.SubflowService.createSubflow(subflow)
                : await this.SubflowService.updateSubflow(state.shortNameOfSubflow, subflow);
            if (action === SubflowModalAction.Create && newSubflow) {
                await this.registerSubflowState(newSubflow.shortName, newSubflow.configuration.name, newSubflow.configuration.image);
                await this.debouncedSave();
            }
            else if (action === SubflowModalAction.Update) {
                if (!newSubflow) {
                    throw new Error('Unable to get the subflow information');
                }
                this.updateStateWithSubflowConfiguration(state, newSubflow.configuration);
            }
            return newSubflow;
        }
        catch (e) {
            console.error(e);
            this.BlipToastService.show(ToastType.Danger, { msg: e });
        }
    }
    async checkTemplateHostingMessageReceiverVersion() {
        const template = await this.BuilderService.getApplicationTemplateAsync(this.application, 'builder');
        if (template.messageReceivers && !template.messageReceivers[0].state) {
            //It means that the TH is in the old version
            this.application.applicationJson.messageReceivers[0].state = undefined;
        }
    }
    registerEnteringCustomActionsForSubflow(state) {
        if (!state.shortNameOfSubflow || state.shortNameOfSubflow === '') {
            return;
        }
        this.ActionContentService.setStateAction(state, ActionType.TrackEvent, '$enteringCustomActions', {
            category: state.id,
            action: `Entering subflow - ${state.id}`,
            subflowDefaultAction: true,
        });
        this.ActionContentService.setStateAction(state, ActionType.MergeContact, '$enteringCustomActions', {
            extras: {
                subflowId: state.id,
            },
            subflowDefaultAction: true,
        });
    }
    async registerSubflowState(shortName, title, imageUri) {
        this.isSaving = true;
        try {
            const state = this.createSubflowState(shortName, title, imageUri);
            const addStateIAction = new AddStateIAction({
                data: {
                    state: {
                        $title: state.$title,
                        id: state.id,
                    },
                    ...state,
                },
                execute: async () => {
                    await this.addAndEditState(state);
                },
                undo: data => {
                    this.deleteSelectedState(data.id);
                },
            });
            this.UndoRedoService.add(addStateIAction);
            this.clearSearch();
            await this.addAndEditState(state, false, undefined, false);
            this.createBlockTracking('Subflow');
            this.registerEnteringCustomActionsForSubflow(state);
            await this.saveFlow();
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.setAddingBlockValue(false);
            this.isSaving = false;
        }
    }
    async addAiAnswersState() {
        try {
            if (!this.answersConfiguration) {
                this.toggleAnswersModal();
            }
            else {
                const title = await this.$translate('builder.node.defaultAiAnswersTitle');
                const extras = { assistantId: this.answersConfiguration.assistantId };
                const state = this.BuilderStateService.createState(AI_ANSWERS_TEMPLATE_TYPE, title, undefined, extras);
                const addStateIAction = new AddStateIAction({
                    data: {
                        state: {
                            $title: state.$title,
                            id: state.id,
                        },
                        ...state,
                    },
                    execute: async () => {
                        await this.addAndEditState(state);
                    },
                    undo: data => {
                        this.deleteSelectedState(data.id);
                    },
                });
                this.UndoRedoService.add(addStateIAction);
                this.clearSearch();
                await this.addAndEditState(state);
                // Track event
                this.createBlockTracking('Answers');
            }
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.setAddingBlockValue(false);
        }
    }
    async addDeskState() {
        try {
            const defaultTitle = await this.$translate('builder.node.defaultDeskTitle');
            const state = this.createDeskState(defaultTitle);
            const addStateIAction = new AddStateIAction({
                data: {
                    state: {
                        $title: state.$title,
                        id: state.id,
                    },
                    ...state,
                },
                execute: async () => {
                    await this.addAndEditState(state);
                },
                undo: data => {
                    this.deleteSelectedState(data.id);
                },
            });
            this.UndoRedoService.add(addStateIAction);
            this.clearSearch();
            await this.addAndEditState(state);
            if (this.isAttendanceRulesBuilderEnabled) {
                this.checkAttendanceBlock(this.flow);
            }
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.createBlockTracking('Desk');
            this.setAddingBlockValue(false);
        }
    }
    async openExclusiveComponentsModelView() {
        const modal = await this.ModalService.showModal({
            template: ExclusiveComponentsModalView,
            controller: ExclusiveComponentsModalController,
            controllerAs: '$ctrl',
            inputs: {
                addBlipChatCopyAndPasteState: this.addBlipChatCopyAndPasteState.bind(this),
            },
        });
        await modal.close;
    }
    async addSmartSalesState() {
        try {
            this.isLoading = true;
            const state = await this.SmartSalesService.createSmartSalesState();
            if (!state) {
                this.showSmartSalesModalToInstall();
            }
            this.SmartSalesService.setSmartSalesStateInformation({
                flowIdentifier: this.flowId,
                botIdentifier: this.account.identity,
                stateId: state.id,
            });
            const addStateIAction = new AddStateIAction({
                data: {
                    state: {
                        $title: state.$title,
                        id: state.id,
                    },
                    ...state,
                },
                execute: async () => {
                    await this.addAndEditState(state);
                },
                undo: data => {
                    this.deleteSelectedState(data.id);
                },
            });
            this.UndoRedoService.add(addStateIAction);
            await this.addAndEditState(state);
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.isLoading = false;
            this.createBlockTracking(SmartSalesConstants.BLOCK_TYPE_FOR_TRACKING);
            this.setAddingBlockValue(false);
        }
    }
    async addBlipChatCopyAndPasteState() {
        try {
            this.isLoading = true;
            const state = await this.ExclusiveComponentsService.createBlipChatCopyAndPaste();
            if (state) {
                const addStateIAction = new AddStateIAction({
                    data: {
                        state: {
                            $title: state.$title,
                            id: state.id,
                        },
                        ...state,
                    },
                    execute: async () => {
                        await this.addAndEditState(state);
                    },
                    undo: data => {
                        this.deleteSelectedState(data.id);
                    },
                });
                this.UndoRedoService.add(addStateIAction);
                await this.addAndEditState(state);
            }
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.isLoading = false;
            this.setAddingBlockValue(false);
        }
    }
    async addAiAgentState() {
        try {
            this.isLoading = true;
            const defaultTitle = await this.$translate('builder.node.defaultAiAgentTitle');
            const configuration = await this.BuilderAiAgentService.getDefaultConfiguration(true);
            const state = this.BuilderStateService.createAiAgentState(defaultTitle, configuration);
            const addStateIAction = new AddStateIAction({
                data: {
                    state: {
                        $title: state.$title,
                        id: state.id,
                    },
                    ...state,
                },
                execute: async () => {
                    await this.addAndEditState(state);
                },
                undo: data => {
                    this.deleteSelectedState(data.id);
                },
            });
            this.UndoRedoService.add(addStateIAction);
            this.clearSearch();
            await this.addAndEditState(state);
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.isLoading = false;
            this.setAddingBlockValue(false);
            this.createBlockTracking(AiAgentConstants.BLOCK_TYPE_FOR_TRACKING);
        }
    }
    async addPaymentState() {
        try {
            this.isLoading = true;
            const defaultTitle = await this.$translate('builder.node.defaultPaymentTitle');
            const state = this.createPaymentState(defaultTitle);
            const addStateIAction = new AddStateIAction({
                data: {
                    state: {
                        $title: state.$title,
                        id: state.id,
                    },
                    ...state,
                },
                execute: async () => {
                    await this.addAndEditState(state);
                },
                undo: data => {
                    this.deleteSelectedState(data.id);
                },
            });
            this.UndoRedoService.add(addStateIAction);
            this.clearSearch();
            await this.addAndEditState(state);
        }
        catch (e) {
            console.error(e);
        }
        finally {
            this.isLoading = false;
            this.setAddingBlockValue(false);
            this.createBlockTracking(PaymentConstants.BLOCK_TYPE_FOR_TRACKING);
        }
    }
    setAddingBlockValue(isAddingBlock) {
        this.isAddingBlocks = isAddingBlock;
    }
    createBlockTracking(typeOfBlock, payload = {}) {
        const trackEvent = this.application.isSubflow ? BUILDER_BLOCK_SUBFLOW_CREATED : BUILDER_BLOCK_CREATED;
        payload.BlockType = typeOfBlock;
        this.SegmentService.createApplicationTrack({ trackEvent, application: this.application, payload });
    }
    getLatestAgentVersion() {
        this.latestVersion = this.BuilderAiAgentService.getAgentBlockLatestVersion();
    }
    showUpdateVersionBanner() {
        if (!this.hasAgentBlockToUpdate) {
            this.hasAgentBlockToUpdate = true;
        }
    }
    checkOutdatedStateVersion(state) {
        if (this.isSmartSalesId(state.id)) {
            return !this.SmartSalesService.isSmartSalesStateVersionUpToDate(state.stateVersion);
        }
        if (this.isAiAgentId(state.id) && this.BuilderAiAgentService.isAgentBlockOutdated(state) && this.isStudioVersioningEnabled) {
            this.showUpdateVersionBanner();
            this.agentBlocksThatNeedUpdate.add(state);
            return true;
        }
        return this.displayUpgradeDeskVersion
            && (state.id?.startsWith(DESK_ID_PREFIX)
                && (this.BuilderStateService.deskStateVersion > parseFloat(state.deskStateVersion) || !state.deskStateVersion));
    }
    hideCreateOutputByDiagram(state) {
        if (this.isAiAgentId(state.id) || this.isPaymentId(state.id)) {
            return true;
        }
        return false;
    }
    createNearbyPositionValues() {
        const positions = this.g2p.getPositions();
        let left, top;
        left = (positions.posX || 0) + Math.floor(Math.random() * 100) + 100;
        top = (positions.posY || 0) + Math.floor(Math.random() * 100) + 150;
        if (this.zoomSlider.value < 100) {
            const toZoom = 1.0 + (100 - this.zoomSlider.value) / 100;
            left = positions.posX * toZoom;
            top = positions.posY * toZoom;
        }
        return {
            top: top,
            left: left,
        };
    }
    createNearbyPosition() {
        const positions = this.createNearbyPositionValues();
        return {
            top: `${positions.top}px`,
            left: `${positions.left}px`,
        };
    }
    getStatesBoundingBox(states) {
        let mostTop = Number.POSITIVE_INFINITY;
        let mostLeft = Number.POSITIVE_INFINITY;
        let mostBottom = -Number.POSITIVE_INFINITY;
        let mostRight = -Number.POSITIVE_INFINITY;
        const height = 100;
        const width = 175;
        for (const state of states) {
            const top = parseInt(state.$position.top.slice(0, -2));
            const left = parseInt(state.$position.left.slice(0, -2));
            if (top < mostTop) {
                mostTop = top;
            }
            if (left < mostLeft) {
                mostLeft = left;
            }
            const bottom = top + height;
            const right = left + width;
            if (bottom > mostBottom) {
                mostBottom = bottom;
            }
            if (right > mostRight) {
                mostRight = right;
            }
        }
        return {
            top: mostTop,
            left: mostLeft,
            height: mostBottom - mostTop,
            width: mostRight - mostLeft,
        };
    }
    async addAndEditState(state, fromOutput = false, nearbyPosition, callDebouncedSave = true) {
        state.$position = nearbyPosition ?? this.createNearbyPosition();
        this.flow[state.id] = state;
        // Update agent contexts and flow variables when a new state is added
        this.AgentContextService.updateFromFlow(this.flow);
        this.FlowVariablesService.updateFromFlow(this.flow, this.configuration);
        // Update grounding tools migration alert
        await this.updateGroundingToolsMigrationAlert();
        if (callDebouncedSave) {
            await this.debouncedSave();
        }
        if (this.isSubflowId(state.id)) {
            this.SubflowService.changeActive(state.shortNameOfSubflow, true);
        }
        if (!fromOutput) {
            this.$timeout(async () => {
                const nodeElement = document.getElementById(state.id);
                this.selectNode(nodeElement, true);
                await this.editState(state);
            });
        }
        return state.$position;
    }
    createContentState(title) {
        return this.BuilderStateService.createState(CONTENT_TEMPLATE_TYPE, title);
    }
    createDeskState(title, stateId) {
        return this.BuilderStateService.createState(DESK_TEMPLATE_TYPE, title, stateId, undefined, undefined, undefined, this.onLeavingFromDeskSettings);
    }
    createPaymentState(title) {
        return this.BuilderStateService.createPaymentState(title);
    }
    createSubflowState(shortNameOfSubflow, title, imageUri, stateId, extras) {
        return this.BuilderStateService.createState(SUBFLOW_TEMPLATE_TYPE, title, stateId, extras, imageUri, shortNameOfSubflow);
    }
    validateState(state) {
        this.stateViewModelValidator.validate(state);
        if (this.application.isSubflow) {
            this.subflowStateViewModelValidator.validate(state);
        }
    }
    async onOutputChange(state, output, newTarget, oldTarget) {
        try {
            this.isBinding = true;
            if (oldTarget === undefined) {
                await this.onOutputChangeWithoutOld(state, newTarget, output);
            }
            else {
                if (oldTarget !== '') {
                    this.clearNodeConnections(state.id, oldTarget, output);
                }
                await this.onOutputChangeWithEmptyOrOldTarget(state, newTarget, output, oldTarget);
            }
        }
        catch (e) {
            this.isBinding = false;
        }
        finally {
            try {
                this.validateState(state);
                state.$invalid = false;
            }
            catch (e) {
                console.info(e);
                state.$invalid = true;
            }
            finally {
                this.debouncedSave();
                this.isBinding = false;
            }
        }
    }
    async onOutputChangeWithEmptyOrOldTarget(state, newTarget, output, oldTarget) {
        const connObj = !OutputViewModel.isVariableValue(newTarget) ? this.builderInstance.connect(connectionStyle(state.id, newTarget)) : undefined;
        const outputIndex = this.flow[state.id].$conditionOutputs.findIndex((out) => out === output);
        this.flow[state.id].$conditionOutputs[outputIndex].typeOfStateId = output.typeOfStateId;
        this.flow[state.id].$conditionOutputs[outputIndex].stateId = newTarget;
        this.flow[state.id].$conditionOutputs[outputIndex].$connId = connObj?.id;
        await this.redrawOldConnection(state.id, oldTarget);
        await this.removeUnnecessaryConnection(state.id);
        await this.validateState(state);
    }
    async onOutputChangeWithoutOld(state, newTarget, output) {
        this.clearNodeConnections(state.id, newTarget, output);
        const outputIndex = this.flow[state.id].$conditionOutputs.findIndex((out) => out.$id === output.$id);
        if (outputIndex === -1) {
            throw new Error('Output to delete not found in state outputs');
        }
        this.flow[state.id].$conditionOutputs.splice(outputIndex, 1);
        await this.redrawOldConnection(state.id, newTarget);
        await this.removeUnnecessaryConnection(state.id);
    }
    async showEditSideBar(state, onStateChanged, onOutputChange) {
        return await this.SidebarContentService.showSidebar({
            controller: BuilderSidebarController,
            controllerAs: '$ctrl',
            template: BuilderSidebarView,
            appendToElement: this.$document[0].getElementById('main-content-area'),
            inputs: {
                targetState: state,
                states: this.flow,
                application: this.application,
                $translate: this.$translate,
                TagsService: this.TagsService,
                builderInstance: this.builderInstance,
                UndoRedoService: this.UndoRedoService,
                $onStateChanged: onStateChanged,
                $onOutputChange: onOutputChange,
                $onAddNewState: async (action) => {
                    const { state, output, newTarget: label, oldTarget, } = action;
                    await this.addContentFromOutput({
                        state,
                        output,
                        label,
                        oldTarget,
                    });
                },
                $onAddNewSurvey: async (action) => {
                    const { state, output, template, oldTarget, } = action;
                    await this.addContentSurveyFromOutput({
                        state,
                        output,
                        template,
                        oldTarget,
                    });
                },
            },
            sidebarId: state.id,
        });
    }
    async editState(state) {
        const sidenav = await this.showEditSideBar(state, async (state) => {
            await this.saveState(state);
        }, async (outputChangeProps) => {
            const { state, output, newTarget, oldTarget, } = outputChangeProps;
            await this.onOutputChange(state, output, newTarget, oldTarget);
        });
        try {
            this.editingState = state;
            this.validateState(state);
            this.$rootScope.$broadcast(CloseEditorIfOpenedEvent);
            if (this.application.isSubflow && state.id === STATE_ID_END) {
                this.BuilderSegmentService.trackSubflowEndBlockClicked(this.application);
            }
        }
        finally {
            sidenav.closeDeferred.promise.then(() => {
                this.editingState = undefined;
            });
        }
    }
    tryDeleteDefaultNodes(stateId, selectedNodesAmount) {
        if (stateId === STATE_ID_ONBOARDING || stateId == STATE_ID_FALLBACK) {
            const errorMsg104 = this.$translate.instant('utils.errorMsg.104');
            this.ngToast.danger(errorMsg104);
            this.trackBlockDeleted(false, selectedNodesAmount);
            return true;
        }
        return false;
    }
    deleteState(stateId) {
        const deletedStates = [];
        const selectedNodesAmount = this.selectedNodes.length;
        if (this.selectedNodes.length > 1 && this.multipleBlocksCounter === 0) {
            const segmentPayload = { 'Action': 'Delete', 'NumberOfBlocks': this.selectedNodes.length };
            this.trackBlockMulti(true, segmentPayload);
            this.multipleBlocksCounter = this.selectedNodes.length;
        }
        if (this.multipleBlocksCounter !== 0) {
            this.multipleBlocksCounter -= 1;
        }
        if (stateId && this.selectedNodes.length === 0) { //In case no block is selected, the function will delete the block which the id was passed as parameter
            this.selectNode(document.getElementById(stateId));
        }
        const flow = angular.copy(this.flow);
        const selectedNodes = this.selectedNodes.map(n => typeof n === 'string' && n || n.id);
        if (this.selectedNodes.length > 0) {
            this.selectedNodes.forEach(stateValue => {
                const currentState = flow[stateValue.id || stateValue];
                const detachedStates = this.deatachNodeFromAllStates(currentState.id || stateValue.id || stateValue);
                const deleteStateIAction = new DeleteStateIAction({
                    data: {
                        state: currentState,
                        detachedStates,
                        selectedNodes,
                        historicOfCustomOutputConditions: [],
                    },
                    undo: (data) => {
                        try {
                            this.flow[data.state.id] = angular.copy(data.state);
                            this.createStateNode(this.flow[data.state.id]);
                            if (this.isSubflowId(data.state.id)) {
                                this.SubflowService.changeActive(data.state.shortNameOfSubflow, true);
                            }
                            if (this.isSmartSalesId(data.state.id)) {
                                this.SmartSalesService.setTokenApplicationByState(data.state);
                                this.SmartSalesService.setSmartSalesStateInformation({
                                    flowIdentifier: this.flowId,
                                    botIdentifier: this.account.identity,
                                    stateId: data.state.id,
                                });
                            }
                            if (this.isAiAgentId(data.state.id)) {
                                this.BuilderAiAgentService.extractAiAgentsLocalCustomActionsToPublish(data.state, AgentState.DEVELOPMENT);
                                this.BuilderAiAgentService.extractAiAgentsGroundingLocalCustomActionsToPublish(data.state, AgentState.DEVELOPMENT);
                            }
                            this.$timeout(() => {
                                this.createConnectionsForState(this.flow[data.state.id].id);
                                data.detachedStates
                                    .filter(({ detachedStateId }) => !data.selectedNodes.includes(detachedStateId))
                                    .filter(({ detachedStateId }) => this.flow[detachedStateId])
                                    .filter(({ detachedStateId, output }) => this.flow[detachedStateId].$conditionOutputs.every(c => c.$id !== output.$id || c.$isDeskOutput || c.$isSmartSalesOutput))
                                    .forEach(({ detachedStateId, output, defaultOutput }) => {
                                    if (defaultOutput) {
                                        this.flow[detachedStateId].$defaultOutput = output;
                                    }
                                    else if (output.$isDeskOutput) { // Desk outputs are not deleted, so they should be replaced
                                        if (!output.stateId) {
                                            const deskIndex = data.historicOfCustomOutputConditions.findIndex(deskOutput => deskOutput.connId === output.$connId);
                                            output.stateId = deskIndex > -1 ? data.historicOfCustomOutputConditions.splice(deskIndex, 1)[0].stateId : '';
                                        }
                                        const outputIndex = this.flow[detachedStateId].$conditionOutputs.findIndex(c => c.$id === output.$id);
                                        if (outputIndex !== -1) {
                                            this.flow[detachedStateId].$conditionOutputs[outputIndex] = output;
                                        }
                                        try {
                                            this.validateState(this.flow[detachedStateId]);
                                            this.flow[detachedStateId].$invalid = false;
                                        }
                                        catch (e) {
                                            this.flow[detachedStateId].$invalid = true;
                                        }
                                    }
                                    else if (output.$isSmartSalesOutput) {
                                        if (!output.stateId) {
                                            const smartSalesIndex = data.historicOfCustomOutputConditions.findIndex(customOutput => customOutput.connId === output.$connId);
                                            output.stateId = smartSalesIndex > -1 ? data.historicOfCustomOutputConditions.splice(smartSalesIndex, 1)[0].stateId : '';
                                        }
                                        this.flow[detachedStateId].$conditionOutputs = this.flow[detachedStateId].$conditionOutputs.map(currentConditions => {
                                            if (currentConditions.$connId !== output.$connId) {
                                                return currentConditions;
                                            }
                                            return output;
                                        });
                                        try {
                                            this.validateState(this.flow[detachedStateId]);
                                            this.flow[detachedStateId].$invalid = false;
                                        }
                                        catch (e) {
                                            this.flow[detachedStateId].$invalid = true;
                                        }
                                    }
                                    else {
                                        this.flow[detachedStateId].$conditionOutputs = this.flow[detachedStateId].$conditionOutputs.concat(output);
                                    }
                                    this.bindStateConnections(detachedStateId);
                                });
                                this.debouncedSave();
                            }, 150); // Elapsed time to create node element and bind event listeners
                        }
                        catch (e) {
                            console.error(e);
                        }
                    },
                    execute: (data) => {
                        this.isBinding = true;
                        try {
                            data.detachedStates
                                .filter(({ detachedStateId }) => !data.selectedNodes.includes(detachedStateId))
                                .filter(({ detachedStateId }) => this.flow[detachedStateId])
                                .forEach(({ detachedStateId, output, defaultOutput }) => {
                                if (defaultOutput) {
                                    this.flow[detachedStateId].$defaultOutput = new OutputViewModel({
                                        stateId: STATE_ID_FALLBACK,
                                    });
                                }
                                else {
                                    const outputIndex = this.flow[detachedStateId].$conditionOutputs.findIndex(c => c.$id === output.$id);
                                    if (outputIndex > -1) {
                                        if (output.$isDeskOutput || output.$isSmartSalesOutput) {
                                            data.historicOfCustomOutputConditions.push({
                                                connId: output.$connId,
                                                stateId: output.stateId,
                                            });
                                            this.flow[detachedStateId].$invalid = true;
                                            output.stateId = '';
                                        }
                                        else {
                                            this.flow[detachedStateId].$conditionOutputs.splice(outputIndex, 1);
                                        }
                                    }
                                }
                            });
                            data.selectedNodes.forEach(s => this.flushAndDeleteState(s, selectedNodesAmount));
                        }
                        finally {
                            this.isBinding = false;
                        }
                    },
                });
                // Add single action to array to enable multiple delete state action on undo/redo
                deletedStates.push(deleteStateIAction);
                this.isBinding = true;
                try {
                    this.flushAndDeleteState(stateValue.id || stateValue, selectedNodesAmount);
                }
                finally {
                    this.isBinding = false;
                }
            });
            this.selectedNodes = [];
        }
        /**
         * Create action for multiple deletes
         */
        if (deletedStates.length > 0) {
            const doAction = (actions, fn) => {
                actions.forEach(action => {
                    fn(action);
                });
                this.debouncedSave();
            };
            const deletedNodesIAction = new DeleteStatesIAction({
                data: {
                    state: deletedStates[0].data.state,
                    actions: deletedStates,
                },
                execute: ({ actions }) => doAction(actions, a => a.execute(a.data)),
                undo: ({ actions }) => doAction(actions, a => a.undo(a.data)),
            });
            this.UndoRedoService.add(deletedNodesIAction);
        }
        if (this.isAttendanceRulesBuilderEnabled) {
            this.checkAttendanceBlock(this.flow);
        }
    }
    async deleteSelectedState(stateId) {
        const selectedNodesAmount = this.selectedNodes.length;
        const hasNativeBlocksOnSelected = this.selectedNodes.some(n => n.id === STATE_ID_ONBOARDING || n.id === STATE_ID_FALLBACK || n.id === STATE_ID_END);
        if (stateId === STATE_ID_END || stateId === STATE_ID_ONBOARDING || stateId === STATE_ID_FALLBACK || hasNativeBlocksOnSelected) {
            const errorMsg104 = this.$translate.instant('utils.errorMsg.104');
            this.ngToast.danger(errorMsg104);
            this.trackBlockDeleted(false, selectedNodesAmount);
            return;
        }
        this.deleteState(stateId);
    }
    async togglePasteFeatureNotAllowedAlert() {
        const message = this.application.isSubflow
            ? 'subflowFeatureNotSupported'
            : 'flowFeatureNotSupported';
        try {
            await this.AlertService.show({
                title: await this.$translate(`builder.${message}.header`),
                body: await this.$translate(`builder.${message}.body`),
                variant: 'error',
                icon: 'error',
                buttons: {
                    confirm: await this.$translate('builder.modalConfirmation'),
                },
                callback: {
                    confirmButtonAction: () => { },
                },
            });
        }
        catch (e) {
            console.error(e);
        }
    }
    async toggleCantPasteContextMenuAlert() {
        const bdsAlert = document.querySelector('bds-modal[id=builder-cant-paste-context-menu]');
        await bdsAlert.toggle();
    }
    async toggleAnswersModal() {
        const bdsAnswersModal = document.querySelector('bds-modal[id=builder-answers-modal]');
        await bdsAnswersModal.toggle();
    }
    async goToAnswersConfiguration() {
        this.$state.go('auth.application.detail.artificialIntelligence', {
            shortName: this.application.shortName,
        });
    }
    duplicateStateObject(state) {
        const duplicatedState = angular.copy(state);
        const duplicatedStateID = uuid();
        duplicatedState.id = duplicatedStateID;
        // Only add the sufix if the state already exists on the flow
        if (!this.isBuilderImprovedCopyPasteFeatureEnabled || this.flow[state.id]) {
            duplicatedState.$title = `${duplicatedState.$title} [Duplicate]`;
        }
        return duplicatedState;
    }
    // Points the older state's id to the ones pasted
    remapStateId(idsMapping) {
        // Only remap if the FT is enabled
        if (!this.isBuilderImprovedCopyPasteFeatureEnabled) {
            return;
        }
        for (const stateAdded of this.pastedStates) {
            const state = this.flow[stateAdded];
            for (const [originalId, newId] of Object.entries(idsMapping)) {
                // Remap the default output
                if (state.$defaultOutput.stateId == originalId) {
                    state.$defaultOutput.stateId = newId;
                }
                // Remap the output conditions
                for (const output of state.$conditionOutputs) {
                    if (output.stateId == originalId) {
                        output.stateId = newId;
                    }
                }
            }
        }
        // Show an error on states in which outputs don't point to another state in the flow.
        // Must be done after everything was mapped prior so the new states alredy point to the correct id.
        for (const stateAdded of this.pastedStates) {
            const state = this.flow[stateAdded];
            if (!this.flow[state.$defaultOutput.stateId]) {
                state.$defaultOutput.stateId = undefined;
                state.$invalid = true;
            }
            for (const output of state.$conditionOutputs) {
                if (!this.flow[output.stateId]) {
                    output.stateId = undefined;
                    output.$invalid = true;
                    state.$invalid = true;
                }
            }
        }
    }
    async $onPasteBlocks() {
        this.ContextMenuService.close();
        if (!this.isBuilderImprovedCopyPasteFeatureEnabled) {
            await this.duplicateUndoRedoStateLocal();
            return;
        }
        let left = undefined;
        let top = undefined;
        const menu = this.ContextMenuService;
        if (menu && menu.menuElement) {
            left = menu.menuElement[0].offsetLeft;
            top = menu.menuElement[0].offsetTop;
        }
        await this.duplicateUndoRedoStateClipboardAtPosition(left, top);
    }
    async duplicateUndoRedoStateClipboardAtPosition(left, top) {
        if (!this.isBuilderImprovedCopyPasteFeatureEnabled) {
            return;
        }
        if (!navigator.clipboard.readText) {
            await this.toggleCantPasteContextMenuAlert();
            return;
        }
        const copiedStatesText = await navigator.clipboard.readText();
        await this.duplicateUndoRedoStateClipboard(copiedStatesText, left, top);
    }
    async duplicateUndoRedoStateClipboard(copiedStatesText, left = undefined, top = undefined) {
        if (!this.isBuilderImprovedCopyPasteFeatureEnabled) {
            return;
        }
        try {
            copiedStatesText = copiedStatesText.replace(/\n/g, '').replace(/\r/g, '').replace(/\t/g, '');
            if (!this.isValidJson(copiedStatesText)) {
                return;
            }
            const copiedStates = JSON.parse(copiedStatesText);
            // Remove isAiGenerated property from states when the user using CTRL + V
            copiedStates.forEach(state => state.isAiGenerated = false);
            await this.duplicateUndoRedoState(copiedStates, left, top);
        }
        catch (e) {
            console.error(e);
            const invalidContentMessage = await this.$translate('builder.pastedBlockIsInvalid');
            this.ngToast.danger(invalidContentMessage);
        }
    }
    async duplicateUndoRedoStateId(stateId) {
        const state = { ...this.flow[stateId] };
        // Remove isAiGenerated property from states when the user using CTRL + V
        state.isAiGenerated = false;
        await this.duplicateUndoRedoState([state]);
    }
    async duplicateUndoRedoStateLocal() {
        if (this.isBuilderImprovedCopyPasteFeatureEnabled) {
            return;
        }
        const copiedStates = this.copiedStates.map(state => this.flow[state]);
        await this.duplicateUndoRedoState(copiedStates);
    }
    async duplicateUndoRedoStateFromViewModel(copiedFlow, left = undefined, top = undefined) {
        const copiedStates = Object.keys(copiedFlow).map((key) => copiedFlow[key]);
        await this.duplicateUndoRedoState(copiedStates, left, top);
    }
    async duplicateUndoRedoState(copiedStates, left = undefined, top = undefined) {
        if (!copiedStates || !copiedStates.length) {
            return;
        }
        this.segmentPayload = { NumberOfBlocks: this.selectedNodes.length };
        const duplicatedStates = [];
        this.pastedStates = [];
        const idsMapping = {}; // This is used to map the older states id to the new ones being creted.
        this.deselectAllNodes(); // Deselect all states so the new ones can be selected.
        // Find the difference between the state top-left and the new position.
        // All new blocks will be moved by theses values, so they mantain the same relative position.
        const statesBoundingBox = this.getStatesBoundingBox(copiedStates);
        let nearbyPosition;
        if (left === undefined || top === undefined) {
            nearbyPosition = this.createNearbyPositionValues();
        }
        else {
            // Offset by the size so its centered
            nearbyPosition = {
                top: top - statesBoundingBox.height / 2,
                left: left - statesBoundingBox.width / 2,
            };
        }
        const diffTop = nearbyPosition.top - statesBoundingBox.top;
        const diffLeft = nearbyPosition.left - statesBoundingBox.left;
        let pastedSubflow = false;
        copiedStates
            .filter(stateValue => stateValue.hasOwnProperty('id')) // Guarantees what was pasted at least has an id
            .forEach(async (stateValue) => {
            if (stateValue.id === STATE_ID_ONBOARDING || stateValue.id == STATE_ID_FALLBACK || stateValue.id == STATE_ID_END) {
                const errorMsg104 = this.$translate.instant('utils.errorMsg.104');
                this.ngToast.danger(errorMsg104);
                this.trackBlockCopied(false);
                return false;
            }
            if (this.isSubflowId(stateValue.id)) {
                pastedSubflow = true;
                stateValue.$enteringCustomActions = [];
                return false;
            }
            const previousId = stateValue.id;
            const currentDuplicatedState = angular.copy(this.duplicateStateObject(stateValue));
            if (this.isAnswersState(stateValue)) {
                currentDuplicatedState.id = ANSWERS_ID_PREFIX + currentDuplicatedState.id;
            }
            // Adds the "desk" prefix to the id if the original is a desk state
            if (this.isDeskState(stateValue)) {
                currentDuplicatedState.id = DESK_ID_PREFIX + currentDuplicatedState.id;
            }
            // Adds the "survey" prefix to the id if the original is a survey state
            if (this.isSurveyState(stateValue)) {
                currentDuplicatedState.id = SURVEY_ID_PREFIX + currentDuplicatedState.id;
            }
            if (this.isSmartSalesId(stateValue.id)) {
                const smartSalesOwner = await this.SmartSalesService.getSmartSalesOwner(this.useConfigurationsApplication);
                if (!smartSalesOwner) {
                    this.BlipToastService.show(ToastType.Danger, {
                        title: await this.$translate('builder.smartSales.error.paste.title'),
                        msg: await this.$translate('builder.smartSales.error.paste.body'),
                        buttonText: await this.$translate('builder.smartSales.error.paste.button'),
                        callback: async () => await this.SmartSalesService.redirectToInstallPlugin(),
                    });
                    return;
                }
                this.SmartSalesService.mergeSmartSalesState(await this.SmartSalesService.createSmartSalesState(), currentDuplicatedState);
                this.SmartSalesService.setSmartSalesStateInformation({
                    flowIdentifier: this.flowId,
                    botIdentifier: this.account.identity,
                    stateId: currentDuplicatedState.id,
                });
            }
            if (this.isAiAgentId(stateValue.id)) {
                currentDuplicatedState.id = AiAgentConstants.STATE_ID_PREFIX + currentDuplicatedState.id;
                await this.BuilderAiAgentService.publishAgentConfiguration(currentDuplicatedState, AgentState.DEVELOPMENT);
            }
            // Adds the "payment" prefix to the id if the original is a payment state
            if (this.isPaymentId(stateValue.id)) {
                currentDuplicatedState.id = PAYMENT_ID_PREFIX + currentDuplicatedState.id;
            }
            idsMapping[previousId] = currentDuplicatedState.id;
            this.pastedStates.push(currentDuplicatedState.id);
            if (this.isBuilderImprovedCopyPasteFeatureEnabled) {
                // Updates the new block with the difference position.
                const position = currentDuplicatedState.$position;
                currentDuplicatedState.$position = {
                    top: `${parseInt(position.top.slice(0, -2), 10) + diffTop}px`,
                    left: `${parseInt(position.left.slice(0, -2), 10) + diffLeft}px`,
                };
            }
            else {
                const nearbyposition = this.createNearbyPosition();
                currentDuplicatedState.$position = nearbyposition;
            }
            const duplicateStateIAction = new DuplicateStateIAction({
                data: {
                    state: angular.copy(currentDuplicatedState),
                },
                undo: (data) => {
                    this.deselectAllNodes(); //deselect nodes to void deleting wrong states with deleteSelectedState
                    this.deleteSelectedState(data.state.id);
                },
                execute: (data) => {
                    try {
                        this.flow[data.state.id] = angular.copy(data.state);
                        this.createStateNode(this.flow[data.state.id]);
                        this.$timeout(() => {
                            this.createConnectionsForState(this.flow[data.state.id].id);
                            this.debouncedSave();
                        }, 350); // Elapsed time to create node element and bind event listeners
                    }
                    catch (e) {
                        console.error(e);
                    }
                },
            });
            duplicatedStates.push(duplicateStateIAction);
            this.addAndEditState(currentDuplicatedState, this.isBuilderImprovedCopyPasteFeatureEnabled, currentDuplicatedState.$position);
            if (!this.isBuilderImprovedCopyPasteFeatureEnabled) {
                this.$timeout(() => {
                    const element = document.getElementById(currentDuplicatedState.id);
                    if (element) {
                        this.deselectNode(element);
                    }
                }, 100);
            }
        });
        if (duplicatedStates.length > 0) {
            this.remapStateId(idsMapping);
            const doAction = (actions, fn) => {
                actions.forEach(action => {
                    fn(action);
                });
                this.debouncedSave();
            };
            const duplicateNodesIAction = new DuplicateStatesIAction({
                data: {
                    state: duplicatedStates.length === 1 ? duplicatedStates[0].data.state : { id: '', $title: '' },
                    actions: duplicatedStates,
                },
                execute: ({ actions }) => {
                    doAction(actions, a => a.execute(a.data));
                    this.remapStateId(idsMapping); // When redoing it's necessary to remap the states
                },
                undo: ({ actions }) => doAction(actions, a => a.undo(a.data)),
            });
            this.UndoRedoService.add(duplicateNodesIAction);
        }
        // Revalidates the blocks
        if (this.isBuilderImprovedCopyPasteFeatureEnabled) {
            let pastedInvalidBlockInSubflow = false;
            for (const stateId of this.pastedStates) {
                const state = this.flow[stateId];
                try {
                    this.validateState(state);
                    state.$invalid = false;
                }
                catch (error) {
                    state.$invalid = true;
                }
                // Only show the error message if it's a subflow error
                if (this.application.isSubflow) {
                    try {
                        this.subflowStateViewModelValidator.validate(state);
                    }
                    catch (error) {
                        pastedInvalidBlockInSubflow = true;
                    }
                }
            }
            // Track paste event
            const payload = {
                blocksPastedCount: duplicatedStates.length,
                triedPastingSubflow: pastedSubflow,
                triedPastingInvalidBlockInSubflow: pastedInvalidBlockInSubflow,
            };
            this.BuilderSegmentService.trackBuilderPasteBlocks(payload);
            // Show error message
            if (pastedSubflow || pastedInvalidBlockInSubflow) {
                await this.togglePasteFeatureNotAllowedAlert();
            }
        }
    }
    async upgradeSelectedState(stateId) {
        if (!stateId) {
            return;
        }
        if (stateId === STATE_ID_ONBOARDING || stateId == STATE_ID_FALLBACK) {
            const errorMsg176 = this.$translate.instant('utils.errorMsg.176');
            this.ngToast.danger(errorMsg176);
            return;
        }
        if (this.isSmartSalesId(stateId)) {
            const oldState = angular.copy(this.flow[stateId]);
            const oldStateId = oldState.id;
            const newState = await this.SmartSalesService.createSmartSalesState();
            const mergedState = this.SmartSalesService.mergeSmartSalesState(newState, oldState);
            mergedState.id = oldStateId;
            this.updateState(mergedState, false);
            this.BuilderSegmentService.trackBlockUpgrated({
                BlockType: SmartSalesConstants.BLOCK_TYPE_FOR_TRACKING,
                newVersion: SmartSalesConstants.CURRENT_SMART_SALES_VERSION,
            }, true);
            await this.showToastWithUpdatedBlockMessage();
            return;
        }
        const oldDeskState = angular.copy(this.flow[stateId]);
        if (!this.isDeskState(oldDeskState)) {
            return;
        }
        const newDeskState = this.createDeskState(oldDeskState.$title, oldDeskState.id);
        this.mergeDeskStates(newDeskState, oldDeskState);
        const updateStateIAction = new UpdateStateIAction({
            data: {
                state: angular.copy(oldDeskState),
            },
            undo: (data) => {
                this.flow[data.state.id] = data.state;
                this.closeSidebar();
            },
            execute: (data) => {
                try {
                    const oldDeskState = data.state;
                    const newDeskState = this.createDeskState(oldDeskState.$title);
                    this.mergeDeskStates(newDeskState, oldDeskState);
                    this.flow[data.state.id] = newDeskState;
                    this.closeSidebar();
                    this.$timeout(() => {
                        this.debouncedSave();
                    }, 350); // Elapsed time to create node element and bind event listeners
                }
                catch (e) {
                    console.error(e);
                }
            },
        });
        this.updateState(newDeskState, false);
        this.closeSidebar();
        this.$timeout(() => {
            const element = document.getElementById(newDeskState.id);
            if (element) {
                this.deselectNode(element);
            }
        }, 100);
        const doAction = (actions, fn) => {
            actions.forEach(action => {
                fn(action);
            });
            this.debouncedSave();
        };
        const duplicateNodesIAction = new UpdateStatesIAction({
            data: {
                state: updateStateIAction.data.state,
                actions: [updateStateIAction],
            },
            execute: ({ actions }) => doAction(actions, a => a.execute(a.data)),
            undo: ({ actions }) => doAction(actions, a => a.undo(a.data)),
        });
        this.UndoRedoService.add(duplicateNodesIAction);
        await this.showToastWithUpdatedBlockMessage();
        this.trackBlockUpgrated(true);
    }
    async showToastWithUpdatedBlockMessage() {
        const upgradeSuccessfully = await this.$translate('utils.successMsg.7');
        this.ngToast.success(upgradeSuccessfully);
    }
    mergeDeskStates(newDeskState, oldDeskState) {
        const { $conditionOutputs, $contentActions, $enteringCustomActions, $inputSuggestions, deskStateVersion, ...dataUpgrade } = oldDeskState;
        const conditionOutputs = [];
        newDeskState.$conditionOutputs.forEach(newConditionOutput => {
            const oldConditionOutput = oldDeskState.$conditionOutputs.find(output => JSON.stringify(output.conditions) == JSON.stringify(newConditionOutput.conditions));
            conditionOutputs.push(oldConditionOutput ?? newConditionOutput);
        });
        oldDeskState.$conditionOutputs.forEach(customOutput => {
            if (!conditionOutputs.find(output => output == customOutput)) {
                conditionOutputs.push(customOutput);
            }
        });
        newDeskState.$conditionOutputs = conditionOutputs;
        dataUpgrade.$leavingCustomActions = newDeskState.$leavingCustomActions;
        Object.assign(newDeskState, dataUpgrade);
        return newDeskState;
    }
    async updateState(state, fromOutput = false) {
        this.flow[state.id] = state;
        this.debouncedSave();
        if (!fromOutput) {
            this.$timeout(async () => {
                const nodeElement = document.getElementById(state.id);
                this.selectNode(nodeElement, true);
                await this.editState(state);
            });
        }
    }
    async flushAndDeleteState(stateId, selectedNodesAmount) {
        const element = document.getElementById(stateId);
        if (!element) {
            return;
        }
        if (this.selectedNodes.indexOf(element) >= 0) {
            this.deselectNode(element);
        }
        this.builderInstance.remove(element);
        if (this.isSubflowId(stateId)) {
            const shortNameOfSubflow = this.flow[stateId].shortNameOfSubflow;
            delete this.flow[stateId];
            await this.saveFlow();
            this.SubflowService.changeActive(shortNameOfSubflow, false);
        }
        if (this.isSmartSalesId(stateId)) {
            this.SmartSalesService.setTokenApplicationByState(this.flow[stateId]);
            this.SmartSalesService.deleteSmartSalesState(stateId);
        }
        //Deleting AI Agent content after delete the block
        if (this.isAiAgentId(stateId)) {
            this.BuilderAiAgentService.deleteAgentConfiguration(stateId, AgentState.DEVELOPMENT);
            this.BuilderAiAgentService.deleteToolsConfiguration(stateId, this.application.tenantId, AgentState.DEVELOPMENT);
        }
        delete this.flow[stateId];
        // Update agent contexts and flow variables when a state is deleted
        this.AgentContextService.updateFromFlow(this.flow);
        this.FlowVariablesService.updateFromFlow(this.flow, this.configuration);
        // Update grounding tools migration alert
        await this.updateGroundingToolsMigrationAlert();
        if (this.editingState && this.editingState.id === stateId) {
            this.closeSidebar();
            this.editingState = undefined;
        }
        this.debouncedSave();
        this.trackBlockDeleted(true, selectedNodesAmount);
    }
    async copySelectedNodes() {
        this.trackBlockContextMenuCopied(true);
        this.copySelectedToClipboard();
        this.showCopiedToast();
        this.ContextMenuService.close();
    }
    async copyNodeId(stateId) {
        this.trackBlockIdCopied(true);
        this.copyToClipboard(stateId);
        this.showCopiedToast();
        this.ContextMenuService.close();
    }
    async enterSubflow(state) {
        if (this.isSaving) {
            return;
        }
        const payload = {
            SubflowID: state.id,
            SubflowName: state.$title,
        };
        this.BuilderSegmentService.trackSubflowOpened(payload);
        this.$state.go('auth.application.detail.builder.index', { shortName: `subflow-${state.shortNameOfSubflow}-${this.application.shortName}`, callerSubflow: '', selectedNodeId: undefined });
    }
    onBuilderNodeContextMenu() {
        this.trackBuilderBlockRightClicked(true);
    }
    copyToClipboard(stateId) {
        this.clipboard.copyText(stateId);
    }
    async copySelectedToClipboard() {
        const copiedStates = await Promise.all(this.selectedNodes.map(async (node) => {
            const selectedState = this.flow[node.id];
            if (this.isAiAgentId(selectedState.id)) {
                selectedState
                    .$groundingConfig = await this.BuilderAiAgentService.getCatalogsWithDocuments(selectedState.id, AgentState.DEVELOPMENT);
            }
            return selectedState;
        }));
        this.copiedStates = copiedStates.map((node) => node.id);
        if (this.isBuilderImprovedCopyPasteFeatureEnabled) {
            const jsonCopied = JSON.stringify(copiedStates);
            this.clipboard.copyText(jsonCopied);
        }
    }
    async showCopiedToast() {
        const successMsg30 = await this.$translate('utils.successMsg.30');
        this.ngToast.success(successMsg30);
    }
    async openVarLib() {
        this.clearSearch();
        this.VariablesService.setVariables(this.flow, this.configuration);
        const sidenav = await this.SidebarContentService.showSidebar({
            allowMultiple: true,
            controller: VarLibraryController,
            controllerAs: '$ctrl',
            template: VarLibraryView,
            appendToElement: this.$document[0].getElementById('main-content-area'),
            inputs: {
                userVariables: this.VariablesService.userVariables,
                defaultVariables: this.VariablesService.defaultVariables,
            },
        });
        this.trackFlowVariablesDictionaryOpened();
        const sidenavData = await sidenav.closeDeferred.promise;
        this.editingState = undefined;
        if (sidenavData) {
            this.debouncedSave();
        }
    }
    async editConfig() {
        this.clearSearch();
        this.areKeyboardActionsEnabled = false;
        const sidenav = await this.SidebarContentService.showSidebar({
            controller: BuilderConfigurationSidebarController,
            controllerAs: '$ctrl',
            template: BuilderConfigurationSidebarView,
            appendToElement: this.$document[0].getElementById('main-content-area'),
            inputs: {
                flow: this.flow,
                flowId: this.flowId,
                configuration: this.configuration,
                secretConfiguration: this.secretConfiguration,
                globalActions: this.globalActions,
                application: this.application,
                $translate: this.$translate,
                $onChanged: async (state) => {
                    if (!this.globalActions) {
                        return;
                    }
                    try {
                        this.globalStateViewModelValidator.validate(state);
                        state.$invalid = false;
                    }
                    catch (e) {
                        console.info(e); // tslint:disable-line
                        state.$invalid = true;
                    }
                    finally {
                        await this.saveFlow();
                    }
                },
                ngToast: this.ngToast,
                LoadingService: this.LoadingService,
                scope: this.$scope,
            },
        });
        const sidenavData = await sidenav.closeDeferred.promise;
        this.$timeout(() => { this.BuilderService.validateTab('config-tooltip', this.globalActions); }, 1000);
        this.editingState = undefined;
        if (sidenavData) {
            this.debouncedSave();
        }
        this.areKeyboardActionsEnabled = true;
    }
    async checkUserPermission() {
        const canEdit = this.hasWritePermission();
        if (!canEdit) {
            this.isWriteMode = false;
            this.writeLockNode = await this.BuilderService.getLockNode(this.getLockImplementation(), this.application.shortName);
            this.userHasEditingPermission = false;
            await this.cancelWriteLockLoop();
        }
        else {
            this.userHasEditingPermission = true;
        }
    }
    async shouldAlertUserAboutGroundingToolsMigration() {
        const aiAgentStates = this.getAiAgentStates();
        if (aiAgentStates.length === 0) {
            return false;
        }
        const hasAiAgentStatesOutdated = aiAgentStates.some((state) => !this.BuilderAiAgentService.isAgentVersionUpToDate(state));
        return hasAiAgentStatesOutdated && this.isStudioGroundingToolsMigrationEnabled;
    }
    async updateGroundingToolsVersion() {
        try {
            this.isLoading = true;
            await this.BuilderAiAgentService.migrateGroundingTools();
            const flow = await this.initializeApplicationAndReturnFlow();
            // Update agent contexts from loaded flow
            this.AgentContextService.updateFromFlow(flow);
            const aiAgentStates = this.getAiAgentStates();
            await Promise.all(aiAgentStates.map(async (state) => {
                await this.updateAiAgentStateVersion(state);
            }));
            this.BuilderSegmentService.trackUpdateGroundingToolsVersion();
            this.updateGroundingToolsMigrationAlert();
            const title = await this.$translate('aiAgentGroundingMigrationModal.successToast.title');
            const msg = await this.$translate('aiAgentGroundingMigrationModal.successToast.message');
            this.BlipToastService.show(ToastType.Success, { title, msg });
        }
        catch (e) {
            console.error('[Builder] Failed to update grounding tools version', e);
            const title = await this.$translate('aiAgentGroundingMigrationModal.errorToast.title');
            const msg = await this.$translate('aiAgentGroundingMigrationModal.errorToast.message');
            this.BlipToastService.show(ToastType.Danger, { title, msg });
        }
        finally {
            this.$timeout(() => {
                this.isLoading = false;
            });
        }
    }
    async updateAiAgentStateVersion(state) {
        let settings = this.BuilderAiAgentService.getFlowContent(state);
        if (!settings) {
            console.warn(`[Builder] Cannot update version - no configuration found for state ${state.id}`);
            return;
        }
        if (settings.version === AiAgentConstants.CURRENT_AI_AGENTS_VERSION) {
            return;
        }
        settings = {
            ...settings,
            version: AiAgentConstants.CURRENT_AI_AGENTS_VERSION,
        };
        this.BuilderAiAgentService.setAgentConfigurationOnState(settings, state);
        await this.saveState(state);
    }
    getAiAgentStates() {
        return Object.values(this.flow).filter((state) => this.BuilderAiAgentService.isAiAgentStateInstance(state.id));
    }
    async updateGroundingToolsMigrationAlert() {
        this.showGroundingToolsMigrationAlert = await this.shouldAlertUserAboutGroundingToolsMigration();
    }
    hasWritePermission() {
        try {
            const currentPermissionModel = this.application.isSubflow ?
                this.application.callerApplication.applicationUserPermissionModel : this.application.applicationUserPermissionModel;
            const hasBuilderWritePermission = (permission) => permission.permissionClaim === BUILDER_PERMISSION_CLAIM &&
                permission.permissionAction === WRITE_PERMISSION_ACTION;
            return currentPermissionModel.some(hasBuilderWritePermission);
        }
        catch (e) {
            console.error('[Builder] Failed to retrieve application permissions', e);
            return false;
        }
    }
    /**
     * Remove all output references to state that match to nodeId
     * @param nodeId: node element id, that is the same of state id
     */
    deatachNodeFromAllStates(nodeId) {
        const detachedStates = [];
        const conditionOutputsHistory = this.flow[nodeId]?.$conditionOutputs;
        const nodeFlowItem = this.flow[nodeId];
        for (const key in this.flow) {
            if (!this.flow.hasOwnProperty(key)) {
                continue;
            }
            if (this.flow[key].$defaultOutput == undefined ||
                this.flow[key].$defaultOutput.stateId == nodeId) {
                detachedStates.push({
                    detachedStateId: key,
                    defaultOutput: true,
                    output: new OutputViewModel({
                        stateId: nodeId,
                    }),
                });
                this.flow[key].$defaultOutput = new OutputViewModel({
                    stateId: STATE_ID_FALLBACK,
                });
            }
            this.flow[key].$conditionOutputs = this.flow[key].$conditionOutputs.reduce((array, condition, outputIndex) => {
                if (condition.stateId === nodeId) { //If condition output points to target state id
                    detachedStates.push({
                        detachedStateId: key,
                        output: { ...condition },
                        outputIndex,
                    });
                    if (condition.$isDeskOutput || condition.$isSmartSalesOutput || condition.$isAgentOutput) { // Desk, Smart Sales and AI Agent outputs should not be removed, they should only be cleaned
                        condition.stateId = undefined;
                        return [...array, condition];
                    }
                    return array;
                }
                return [...array, condition];
            }, []);
            if (this.flow[key].id.startsWith(DESK_ID_PREFIX) || this.flow[key].id.startsWith(SmartSalesConstants.STATE_ID_PREFIX) || this.flow[key].id.startsWith(AiAgentConstants.STATE_ID_PREFIX)) {
                try {
                    this.validateState(this.flow[key]);
                    this.flow[key].$invalid = false;
                }
                catch (e) {
                    this.flow[key].$invalid = true;
                }
            }
        }
        if (nodeFlowItem && nodeFlowItem.$conditionOutputs?.length === 0 && conditionOutputsHistory && conditionOutputsHistory?.length !== 0) {
            nodeFlowItem.$conditionOutputs = conditionOutputsHistory;
        }
        return detachedStates;
    }
    async saveState(state) {
        // If the state was deleted, ignore.
        if (!this.flow[state.id]) {
            return;
        }
        try {
            this.validateState(state);
            state.$invalid = false;
            this.bindStateConnections(state.id);
            this.builderInstance.repaintEverything();
        }
        catch (e) {
            console.debug(e);
            state.$invalid = true;
        }
        finally {
            this.flow[state.id] = {
                ...state,
            };
            // Update agent contexts and flow variables when a state is saved
            this.AgentContextService.updateFromFlow(this.flow);
            this.FlowVariablesService.updateFromFlow(this.flow, this.configuration);
            await this.debouncedSave();
        }
    }
    async saveFlow() {
        if (!this.isWriteMode) {
            return;
        }
        try {
            this.checkAllOutdatedAgentBlocks();
            this.cachedSearchResults = {};
            this.SavingService.startSaving();
            if (!this.application.isSubflow) {
                const promises = [];
                promises.push(this.BuilderService.setFlow(this.flow));
                promises.push(this.BuilderService.setFlowConfiguration(this.configuration));
                promises.push(this.BuilderService.setGlobalActionsState(this.globalActions));
                if (this.isBuilderSecretConfigurationEnabled &&
                    this.isChangeSecretConfiguration()) {
                    promises.push(this.BuilderService.setSecretConfigurationOnVault(this.secretConfiguration));
                    this.secretConfigurationCurrentItems = { ...this.secretConfiguration };
                }
                await Promise.all(promises);
            }
            else {
                await Promise.all([
                    this.SubflowService.setFlow(this.application.shortName, this.flow),
                    this.SubflowService.setFlowConfiguration(this.application.shortName, this.configuration),
                ]);
            }
        }
        catch (e) {
            const errorMsg103 = await this.$translate('utils.errorMsg.103');
            this.ngToast.danger(errorMsg103);
            console.error(e);
        }
        finally {
            this.SavingService.stopSaving();
        }
    }
    // Segment Methods
    trackBlockUpgrated(success) {
        this.BuilderSegmentService.trackBlockUpgrated({}, success);
    }
    trackBlockCopied(success) {
        this.BuilderSegmentService.trackBlockCopied({}, success);
    }
    trackBlockContextMenuCopied(success) {
        this.BuilderSegmentService.trackBlockContextMenuCopied({}, success);
    }
    trackBlockIdCopied(success) {
        this.BuilderSegmentService.trackBlockIdCopied({}, success);
    }
    trackBuilderBlockRightClicked(success) {
        this.BuilderSegmentService.trackBuilderBlockRightClicked({}, success);
    }
    trackBlockDeleted(success, numberBlocks) {
        this.BuilderSegmentService.trackBlockDeleted({
            NumberBlocks: numberBlocks,
        }, success);
    }
    trackFlowSearched(termUsed, typeOfSearch, isLocked) {
        this.BuilderSegmentService.trackFlowSearched({
            NumberBlocksFound: this.searchedStates.length,
            TermUsed: typeOfSearch ? typeOfSearch[2] : termUsed,
            TypeOfSearch: typeOfSearch ? typeOfSearch[1] : '',
            isLocked,
        }, true);
    }
    trackFlowVariablesDictionaryOpened() {
        this.BuilderSegmentService.trackFlowVariablesDictionaryOpened({}, true);
    }
    trackSubFlowPublished(success, error) {
        this.BuilderSegmentService.trackSubflowPublished({
            Error: error,
            NumberBlocks: Object.keys(this.flow).length,
            AiGeneratedBlockNumber: Object.entries(this.flow).filter(([key, value]) => value?.isAiGenerated).length,
            SubflowID: this.application.id,
            SubflowName: this.application.$title,
        }, success, this.application);
    }
    trackFlowPublished(success, error) {
        const NumberBlocks = Object.keys(this.flow).length;
        const AiGeneratedBlockNumber = Object.entries(this.flow).filter(([key, value]) => value?.isAiGenerated).length;
        if (success) {
            this.BuilderSegmentService.trackPublishSuccess({
                NumberBlocks,
                AiGeneratedBlockNumber,
            });
        }
        else {
            this.BuilderSegmentService.trackPublishError({
                errorDescription: error,
                NumberBlocks,
                AiGeneratedBlockNumber,
            });
        }
        this.BuilderSegmentService.trackFlowPublished({
            NumberBlocks,
            AiGeneratedBlockNumber,
        }, success);
    }
    trackWriteReleased() {
        this.BuilderSegmentService.trackWriteReleased();
    }
    trackWriteRequest() {
        this.BuilderSegmentService.trackWriteRequest();
    }
    trackFlowLoaded(success, timeToLoad) {
        const NumberBlocks = Object.keys(this.flow).length;
        if (this.application.isSubflow) {
            this.BuilderSegmentService.trackSubFlowLoaded({
                NumberBlocks,
                TimeToLoad: timeToLoad,
            }, success);
        }
        else {
            this.BuilderSegmentService.trackFlowLoaded({
                NumberBlocks,
                TimeToLoad: timeToLoad,
            }, success);
        }
    }
    trackBlockMulti(success, segmentPayload) {
        this.BuilderSegmentService.trackBlockMulti(segmentPayload, success);
    }
    trackFlowCommands(success, segmentPayload) {
        // Line temporarily commented out due to migration from Segment to Mixpanel
        // this.BuilderSegmentService.trackFlowCommands(this.application, segmentPayload, success);
    }
    trackBlockUndo(success, segmentPayload) {
        this.BuilderSegmentService.trackBlockUndo(segmentPayload, success);
    }
    trackBlockRedo(success, segmentPayload) {
        this.BuilderSegmentService.trackBlockRedo(segmentPayload, success);
    }
    trackBlockContentUndo(success, segmentPayload) {
        this.BuilderSegmentService.trackBlockContentUndo(segmentPayload, success);
    }
    trackBlockContentRedo(success, segmentPayload) {
        this.BuilderSegmentService.trackBlockContentRedo(segmentPayload, success);
    }
    trackBlockCrudUndo(success, segmentPayload) {
        this.BuilderSegmentService.trackBlockCrudUndo(segmentPayload, success);
    }
    trackBlockCrudRedo(success, segmentPayload) {
        this.BuilderSegmentService.trackBlockCrudRedo(segmentPayload, success);
    }
    trackBlockOutputUndo(success, segmentPayload) {
        this.BuilderSegmentService.trackBlockOutputUndo(segmentPayload, success);
    }
    trackBlockOutputRedo(success, segmentPayload) {
        this.BuilderSegmentService.trackBlockOutputRedo(segmentPayload, success);
    }
    trackFlowPublishedValidationErrorMessages(isSubflow, message) {
        const validationErrors = message.replace('One or more validation errors occurred: ', '').split(',');
        if (isSubflow) {
            validationErrors.forEach(e => this.trackSubFlowPublished(false, e));
        }
        else {
            validationErrors.forEach(e => this.trackFlowPublished(false, e));
        }
    }
    trackFlowPublishedBackendValidationErrorMessages(isSubflow, message) {
        let error = message.replace('The provided value for configuration \'Application\' is invalid: The application validation failed: One or more errors occurred. (', '').slice(0, -1);
        const regex = /(?=The output state id )*(?=is invalid)/g;
        if (error.match(regex)) {
            error = 'The output state id is invalid';
        }
        if (isSubflow) {
            this.trackSubFlowPublished(false, error);
        }
        else {
            this.trackFlowPublished(false, error);
        }
    }
    getDeskPermissions() {
        const deskCodePermission = 106;
        const permissions = this.application.applicationUserPermissionModel;
        const filterDeskPermission = permissions.filter((permission) => {
            return permission.permissionClaim === deskCodePermission;
        });
        return filterDeskPermission;
    }
    async checkDeskPermission() {
        try {
            const filterDeskPermission = this.getDeskPermissions();
            const permissionsDesk = {
                'NONE': 0,
                'EDIT': 1,
                'ADMIN': 3,
            };
            let permission;
            if (filterDeskPermission.length === 1) {
                permission = filterDeskPermission[0];
            }
            if (permission) {
                if (permission.permissionAction === permissionsDesk.NONE) {
                    this.canSeeRule = false;
                    this.canEditRule = false;
                }
                else if (permission.permissionAction === permissionsDesk.EDIT) {
                    this.canSeeRule = true;
                    this.canEditRule = false;
                }
                else if (permission.permissionAction === permissionsDesk.ADMIN) {
                    this.canSeeRule = true;
                    this.canEditRule = true;
                }
            }
            else {
                this.canSeeRule = false;
                this.canEditRule = false;
            }
        }
        catch (e) {
            this.canSeeRule = false;
            this.canEditRule = false;
            console.error(e);
        }
    }
    checkAttendanceBlock(flow) {
        this.hasAttendanceBlock = Object.keys(flow).filter(key => key.startsWith('desk')).length > 0;
        return this.hasAttendanceBlock;
    }
    async openRulesModal() {
        if (!this.checkAttendanceBlock(this.flow)) {
            this.SegmentService.createBotTrack('builder-helpdesk-rule-no-attendance-block', this.application);
            this.BlipToastService.show('warning', {
                title: this.noAttendanceBlockTitle,
                msg: this.noAttendanceBlockDescription,
                duration: 3000,
            });
            return;
        }
        this.SegmentService.createBotTrack('builder-helpdesk-rule-opened', this.application);
        this.clearSearch();
        const sidenav = await this.SidebarContentService.showSidebar({
            controller: BuilderAttendanceRulesSidebarController,
            controllerAs: '$ctrl',
            template: BuilderAttendanceRulesSidebarView,
            appendToElement: this.$document[0].getElementById('main-content-area'),
            inputs: {
                flow: this.flow,
                flowId: this.flowId,
                configuration: this.configuration,
                globalActions: this.globalActions,
                application: this.application,
                canSeeRule: this.canSeeRule,
                canEditRule: this.canEditRule,
                $translate: this.$translate,
                $onChanged: async (state) => {
                    if (!this.globalActions) {
                        return;
                    }
                    try {
                        this.globalStateViewModelValidator.validate(state);
                        state.$invalid = false;
                    }
                    catch (e) {
                        state.$invalid = true;
                    }
                    finally {
                        await this.saveFlow();
                    }
                },
                ngToast: this.ngToast,
                LoadingService: this.LoadingService,
                scope: this.$scope,
            },
        });
        const sidenavData = await sidenav.closeDeferred.promise;
        this.editingState = undefined;
        if (sidenavData) {
            this.debouncedSave();
        }
    }
    checkAllOutdatedAgentBlocks() {
        this.agentBlocksThatNeedUpdate.clear();
        this.hasAgentBlockToUpdate = false;
        Object.keys(this.flow).forEach((stateId) => {
            const state = this.flow[stateId];
            if (this.isAiAgentId(state.id) && this.BuilderAiAgentService.isAgentBlockOutdated(state)) {
                this.agentBlocksThatNeedUpdate.add(state);
            }
        });
        if (this.agentBlocksThatNeedUpdate.size > 0) {
            this.hasAgentBlockToUpdate = true;
        }
    }
    openGroundingMigrationModal() {
        // Close sidebar before opening modal
        this.closeSidebar();
        const modal = document.getElementById('grounding-migration-modal');
        if (modal) {
            modal.setAttribute('open', 'true');
        }
    }
    async openPreparedBlocksSidebar() {
        this.SegmentService.createOrganizationTrack(BUILDER_BLOCK_SKILLS_SIDEBAR_OPENED);
        this.setAddingBlockValue(false);
        const blipIdPreparedBlocksEnabled = await BuilderFeatures.blipIdPreparedBlocksEnabled();
        const dataToUseInPreparedBlocks = blipIdPreparedBlocksEnabled
            ? { controller: PreparedBlocksController, template: PreparedBlocksView }
            : { controller: PreparedBlocksSidebarController, template: PreparedBlocksSidebarView };
        await this.SidebarContentService.showSidebar({
            controller: dataToUseInPreparedBlocks.controller,
            controllerAs: '$ctrl',
            template: dataToUseInPreparedBlocks.template,
            appendToElement: this.$document[0].getElementById('main-content-area'),
            inputs: {
                $translate: this.$translate,
                scope: this.$scope,
                clipboard: this.clipboard,
                application: this.application,
                duplicateUndoRedoStateClipboard: this.duplicateUndoRedoStateClipboard.bind(this),
            },
        });
    }
    updateStateWithSubflowConfiguration(state, configuration) {
        state.$imageUri = configuration.image;
        state.$title = configuration.name;
    }
    async updateConfigurationOfAllSubflowStates() {
        Object.keys(this.flow).forEach((key) => {
            const state = this.flow[key];
            if (state.shortNameOfSubflow) {
                this.SubflowService.get(state.shortNameOfSubflow).then((subflow) => {
                    this.updateStateWithSubflowConfiguration(state, subflow.configuration);
                });
            }
        });
    }
    changeCanvasPositionInSubflowStateIsNecessary() {
        if (this.application.isSubflow || !this.$stateParams.callerSubflow) {
            return;
        }
        Object.keys(this.flow).forEach((key) => {
            const state = this.flow[key];
            if (state.shortNameOfSubflow === this.$stateParams.callerSubflow) {
                this.changeCanvasPositionToNode(state);
            }
        });
    }
    changeCanvasPositionToNode(nodeState) {
        this.g2p.element.scrollTo({
            top: parseInt(nodeState.$position.top.replace('px', '')) - 100,
            left: parseInt(nodeState.$position.left.replace('px', '')) - 200,
            behavior: 'instant',
        });
    }
    getLockImplementation() {
        return this.application.isSubflow
            ? LockImplementation.New
            : LockImplementation.Old;
    }
    isDeskState(state) {
        if (state.hasOwnProperty('id') && state.id.startsWith(DESK_ID_PREFIX)) {
            return true;
        }
        return state.hasOwnProperty('deskStateVersion') && !!state.deskStateVersion;
    }
    isPaymentState(state) {
        return state.hasOwnProperty('id') && state.id.startsWith(PAYMENT_ID_PREFIX);
    }
    isAnswersState(state) {
        return state.hasOwnProperty('id') && state.id.startsWith(ANSWERS_ID_PREFIX);
    }
    isSurveyState(state) {
        return state.hasOwnProperty('id') && state.id.startsWith(SURVEY_ID_PREFIX);
    }
    isSubflowId(stateId) {
        return stateId.startsWith(SUBFLOW_ID_PREFIX);
    }
    isSmartSalesId(stateId) {
        return stateId.startsWith(SmartSalesConstants.STATE_ID_PREFIX);
    }
    isAiAgentId(stateId) {
        return this.BuilderAiAgentService.isAiAgentStateInstance(stateId);
    }
    isBuilderLockedForEdit() {
        return !this.userHasEditingPermission || !this.isWriteMode;
    }
    isInnerStateElement(element) {
        return ['BDS-TYPO', 'BDS-ICON'].some((item) => item === element.tagName.toUpperCase());
    }
    setFullscreen(fullscreen) {
        this.isFullscreen = fullscreen;
        const body = document.getElementsByTagName('body')[0];
        body.classList.toggle('fullscreen', this.isFullscreen);
    }
    toggleFullscreen() {
        const enteringFullscreen = !this.isFullscreen;
        const payload = { enteringFullscreen };
        this.BuilderSegmentService.trackBuilderFullscreen(payload);
        this.setFullscreen(enteringFullscreen);
    }
    selectNodeByStateParamsIfNecessary() {
        const nodeId = this.$stateParams.selectedNodeId;
        const nodeState = this.flow[nodeId];
        if (!nodeState) {
            return;
        }
        const nodeElement = document.getElementById(nodeId);
        this.changeCanvasPositionToNode(nodeState);
        this.selectNode(nodeElement);
        this.debouncedEditState(nodeState);
    }
    isChangeSecretConfiguration() {
        return JSON.stringify(this.secretConfiguration) !== JSON.stringify(this.secretConfigurationCurrentItems);
    }
    /**
     * This method is called when create subflow its clicked.
     */
    async createCopilotModal() {
        // Tracking
        this.BuilderSegmentService.trackButtonIconRobotAi(this.application);
        this.areKeyboardActionsEnabled = false;
        const modal = await this.ModalService.showModal(copilotModal({
            confirm: async (command) => {
                // Tracking
                await this.BuilderSegmentService.trackButtonIconCreateBlocksAi(this.application);
                try {
                    // Create copilot blocks from user command
                    const flow = await this.CopilotAdapterService.getFlow(command);
                    await this.duplicateUndoRedoStateFromViewModel(flow);
                    // Success toast
                    const msg = await this.$translate('builder.copilot.modal.successToastMessage');
                    this.BlipToastService.show(ToastType.Success, { msg });
                    // FeedbackModal
                    await this.createFeedbackModalForCopilot();
                }
                catch (e) {
                    // Tracking
                    await this.BuilderSegmentService.trackBannerErrorAi(this.application);
                    throw new Error('Failed to create block with copilot.');
                }
            },
            clickOnlearnMoreAboutCopilot: async () => {
                // Tracking
                await this.BuilderSegmentService.trackLinkHelpCenterAi(this.application);
            },
        }));
        const confirmation = await modal.close;
        this.areKeyboardActionsEnabled = true;
        return confirmation;
    }
    async createFeedbackModalForCopilot() {
        await this.ModalService.showModal(feedbackModal({
            body: await this.$translate('builder.copilot.feedbackModal.body'),
            buttons: {
                like: {
                    action: async () => {
                        // Tracking
                        this.BuilderSegmentService.trackButtonIconLiketAi(this.application);
                        const msg = await this.$translate('builder.copilot.feedbackModal.buttons.like.toastMessage');
                        this.BlipToastService.show(ToastType.Info, { msg });
                    },
                },
                deslike: {
                    action: () => {
                        // Tracking
                        this.BuilderSegmentService.trackButtonIconDeslikeAi(this.application);
                    },
                },
            },
        }));
    }
    findSubflowsFromFlow(flow) {
        const subflows = [];
        for (const key in flow) {
            if (Object.prototype.hasOwnProperty.call(flow, key)) {
                if (key.startsWith('subflow:')) {
                    subflows.push(flow[key]);
                }
            }
        }
        return subflows;
    }
    async validateSubflowToPublishing() {
        const subflowsConfigurations = await this.getSubflowsConfigurations();
        const shortNamesOfsubflowsNeverOpened = this.getShortNamesOfSubflowsNeverOpened(this.subflowsShortNames, subflowsConfigurations);
        if (subflowsConfigurations || shortNamesOfsubflowsNeverOpened.length > 0) {
            let shortNameNeverPublished = [];
            if (subflowsConfigurations?.length > 0) {
                shortNameNeverPublished = this.getShortNamesOfConfigurationsNeverPublished(subflowsConfigurations);
            }
            const shortNameNotPublished = shortNamesOfsubflowsNeverOpened?.concat(shortNameNeverPublished);
            if (shortNameNotPublished.length > 0) {
                const toastConfig = {
                    title: '',
                    msg: '',
                    duration: 8000,
                    callback: () => { },
                };
                if (shortNameNotPublished.length === 1) {
                    const subflows = this.findSubflowsFromFlow(this.flow);
                    const subflowName = subflows.find(sub => sub.shortNameOfSubflow === shortNameNotPublished[0]).$title;
                    toastConfig.title = await this.$translate('builder.subflow.publishError.subflowNotPublished.title');
                    toastConfig.msg = await this.$translate('builder.subflow.publishError.subflowNotPublished.msg', { name: subflowName });
                }
                else {
                    toastConfig.title = await this.$translate('builder.subflow.publishError.subflowsNotPublished.title');
                    toastConfig.msg = await this.$translate('builder.subflow.publishError.subflowsNotPublished.msg');
                }
                this.BlipToastService.show('warning', toastConfig);
                return false;
            }
        }
        return true;
    }
    async updateNodeStatus(nodeId) {
        if (nodeId.startsWith('subflow:')) {
            const subflowsConfigurations = await this.getSubflowsConfigurations();
            const subflows = this.findSubflowsFromFlow(this.flow);
            if (subflowsConfigurations) {
                const shortName = subflows.filter(sub => sub.id === nodeId)[0].shortNameOfSubflow;
                const configurationName = subflowsConfigurations.find(sc => sc.shortName === shortName
                    && sc.configurationName === SubflowFlowStatus.PublishedFlow);
                if (configurationName) {
                    return true;
                }
            }
            return false;
        }
    }
    async getSubflowsConfigurations() {
        const subflowsConfigurations = [];
        this.subflowsShortNames = this.SubflowService.getSubflowsShortNameFromFlow(this.flow);
        if (this.subflowsShortNames.length > 0) {
            const subflows = await this.SubflowService.getSubflowsByShortNames(this.subflowsShortNames);
            if (subflows.length > 0) {
                const configurations = await this.SubflowService.getSubflowsConfigurationsById(subflows.map(sub => sub.subflowId));
                configurations.forEach(sub => {
                    const configurations = new SubflowConfigurationWithShortName(sub.name, sub.subflowId, subflows
                        .filter(s => s.subflowId === sub.subflowId)[0].shortName);
                    subflowsConfigurations.push(configurations);
                });
                return subflowsConfigurations;
            }
        }
    }
    getShortNamesOfConfigurationsNeverPublished(subflowsConfigurations) {
        const notPublishedConfigurations = subflowsConfigurations.filter(sub => sub.configurationName !== SubflowFlowStatus.PublishedFlow &&
            sub.configurationName !== SubflowFlowStatus.EditedFlowConfiguration);
        const publishedShortNames = subflowsConfigurations
            .filter(sub => sub.configurationName === SubflowFlowStatus.PublishedFlow)
            .map(sub => sub.shortName);
        const shortNames = notPublishedConfigurations
            .map(sub => sub.shortName)
            .filter(sn => !publishedShortNames.includes(sn));
        return shortNames;
    }
    getShortNamesOfSubflowsNeverOpened(shortNames, subflowsConfigurations) {
        return Array.from(new Set(shortNames.filter(name => !(subflowsConfigurations?.some(sub => sub?.shortName === name)))));
    }
    async showSmartSalesModalToInstall() {
        await this.ModalService.showModal(installSmartSalesPluginModal({
            confirm: async () => {
                this.BuilderSegmentService.trackSmartSalesPluginInstallButtonClick();
                await this.SmartSalesService.redirectToInstallPlugin();
            },
        }));
    }
}
//#endregion
BuilderController.$inject = ['JsPlumbService', 'BuilderService', 'AlertService', 'TenantService', 'BuilderStateService', 'SavingService', 'BuilderSegmentService', 'SegmentService', 'SidebarContentService', 'TagsService', 'VariablesService', '$scope', '$rootScope', '$timeout', 'LoadingService', 'ChatbotSettingsService', 'ngToast', '$translate', '$document', '$stateParams', 'application', 'ModalService', '$state', 'BlipService', 'ChatService', 'ApplicationService2', 'UndoRedoService', 'clipboard', 'ContextMenuService', 'BlipToastService', 'SubflowService', 'ActionContentService', 'SmartSalesService', 'TranslateService', 'CopilotAdapterService', 'AnswersService', 'ExclusiveComponentsService', 'BuilderAiAgentService', 'StudioService', 'AgentContextService', 'FlowVariablesService', 'StudioVersionService'];
